// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
// The Site type is extremely complicated and we don't use 99% of the fields.
// The information in this file is a snapshot in time and is only used briefly before the
// fresh data is downloaded, so it's not worth the effort to keep it up to date.

import Site from "@r6digital/rapidstor-types/types/Site";

const defaultLocations: Site[] = [
  {
    SiteID: 10035,
    sLocationCode: "L001",
    __v: 0,
    sGlobalSiteNum: "22744",
    iRegionalOptions: 1,
    iGMTTimeOffset: 8,
    sContactName: "Shaun Bain",
    sEmailAddress: "info@coastalstorageunits.com.au",
    sSiteName: "Coastal Storage Units - Mandurah",
    sSiteAddr1: "18 Quarry Way",
    sSiteCity: "Greenfields",
    sSiteRegion: "WA",
    sSitePostalCode: "6210",
    sSiteCountry: "AUS",
    sSitePhone: "08 9583 3577",
    bUseInclusiveTaxation: true,
    sTaxNumber: "20 143 725 893",
    dUpdated: "2021-05-13T16:00:54.007Z",
    uTS: "AAAAAAxXSuw=",
    rapidstorEnabled: false,
    iMobileType: "0",
    iOnLineChargeType: "0",
    sSiteFAX: "08 9331 3715",
    sWebSiteURL: "www.coastalstorageunits.com.au",
    iFeatMaxUnits: "100",
    bFeatGate: "true",
    bFeatKiosk: "true",
    bFeatRevMgmt: "true",
    bFeatCreditCards: "true",
    bFeatCorpOffice: "true",
    bFeatAccounting: "true",
    bFeatRecordStorage: "false",
    bFeatACH: "true",
    bFeatMobileStorage: "false",
    bFeatPromoAdvanced: "false",
    dACHStatus: "2014-01-28T18:43:51.933-05:00",
    bLiteVersion: "false",
    bTrial: "false",
    bSubscription: "false",
    bSiteDisabled: "false",
    dGateUpdated: "2021-05-06T14:06:51.223-04:00",
    dOvernightProcess: "2021-05-13T12:00:54.007-04:00",
    bZipCodeData_Use: "false",
    dcLongitude: "115.7543950000",
    dcLatitude: "-32.5130310000",
    bClosedWeekdays: "false",
    bClosedSaturday: "false",
    bClosedSunday: "true",
    dWeekdayStrt: "2011-01-06T08:30:00-05:00",
    dWeekdayEnd: "2011-01-06T17:30:59-05:00",
    dSaturdayStrt: "2011-01-06T08:30:00-05:00",
    dSaturdayEnd: "2011-01-06T17:30:59-05:00",
    dSundayStrt: "2011-01-06T00:00:00-05:00",
    dSundayEnd: "2011-01-06T23:59:59-05:00",
    iIdentifier: "0",
    iBusinessType: "-33",
    iSiteDataType: "0",
    iFacilityUsage: "0",
    iFacilityOwnership: "0",
    iFacilityMgmt: "0",
    iFacilityLocType: "0",
    iMobileBungoRules: "0",
    iOnLinePmtsAllowed: "1",
    iEdition: "1",
    iTerminalServices: "0",
    iDST: "0",
    dCreated: "2014-01-28T18:43:52.207-05:00",
    bPermanent: "false",
    bArchived: "false",
    iVerboseLogging: "0",
    iSiteLinkStoreTier: "1",
    sSLBillingRef: "DQS001",
    iSubscriptionType: "0",
    tWeekdayStrt: "08:30:00",
    tWeekdayEnd: "17:30:59",
    tSaturdayStrt: "08:30:00",
    tSaturdayEnd: "17:30:59",
    tSundayStrt: "00:00:00",
    tSundayEnd: "23:59:59",
    sLocationDesc: null,
    sSiteIDCode: null,
    sSiteRegionCode: null,
    sSiteAddr2: null,
    sLegalName: null,
    sIdentifier: null,
    bForcePushRates: "1",
    iWebRatesType: "0",
    token:
      "e464dbe8629fdb667dfc43547c8e7c60b2d62491b2af46a7aa6ebfdc795247ac940198fe585361e4fed1451233b6925f",
    changedAt: "2021-05-23T21:17:15.576Z",
    changeToken:
      "2277b0dd3da4019f6c605f025dd16af2d541839dea734354b6a33f3373f5967e5af1e021dcbdd9bf84cc069d452b71a3",
    deleted: false,
    administrative: {
      boxshopEnabled: true,
      testMode: false,
      rslite: false,
      rsliteKey: "N/A",
      refreshEnabled: false,
      availableForUse: false,
      insuranceEnabled: false,
      merchEnabled: false,
      carouselListing: false,
      useMtasForAuth: false,
    },
    rapidstor: {
      pushRate: true,
      marketingSurvey: {
        use: true,
        questions: {
          whereHearAboutUs: {
            display: true,
            required: true,
          },
          distanceFromFacility: {
            display: true,
            required: true,
          },
          whyStoring: {
            display: true,
            required: true,
          },
          customerType: {
            display: true,
            required: true,
          },
          whatStoring: {
            display: true,
            required: true,
          },
          whyStoringWithUs: {
            display: true,
            required: true,
          },
        },
      },
      country: "AU",
      unitListing: {
        sortOrder: {
          primary: "size",
          secondary: "price",
          tertiary: "availability",
        },
        useMultilevel: false,
      },
      siteLogo:
        "https://ik.imagekit.io/bytcx9plm/CDQS-L001-logo-cjilmq63k01e5hfd69ocyu1d5.png",
      allowOriginUrl: [],
      allowedCreditCardTypes: {
        visa: true,
        mastercard: true,
        amex: false,
      },
      billingDefault: "MonthlyFirstOfMonth",
      smallMediumSize: 3,
      mediumLargeSize: 9,
      moveinHideAcp: false,
      hideBoxshop: true,
      currencySymbol: "$",
      shippingEnabled: false,
      sizeSymbol: "m",
      allowReservation: true,
      allowMoveIn: true,
      minAvailableUnits: 0,
      hideUnitsMinAvailable: true,
      noAvailableUnitsText: "Call for Availability",
      hideQuickSearch: false,
      insuranceRequired: false,
      hideInsurance: false,
      hideLicenseState: true,
      hideDateOfBirth: true,
      autoOptInSms: false,
      legacyPickupLocationsEnabled: false,
      freeShippingDealEnabled: false,
      freeShippingDealAmount: 150,
      reservationNumberOfDaysInAdvanceLimit: 14,
      moveinNumberOfDaysInAdvanceLimit: 7,
      reservationNumberOfDaysInAdvanceChargeFee: 365,
      notificationsFromAddress: "",
      completeMoveinUrl: "",
      useESign: false,
      useAutoBilling: true,
      autoBillCheckedByDefault: false,
      doNotSendInvoiceSiteLinkWhenAutoBill: false,
      quickReserveButtonText: "Quick Reserve",
      hideLicense: false,
      hideState: false,
      hidePostalCode: false,
      groundFloor: 0,
      assistanceMoving: false,
      assistanceMovingEmailAddress: "",
      areaSizeSymbol: "m²",
      attachLeaseToMoveInConfirmationEmail: true,
      attachReceiptToMoveInConfirmationEmail: true,
      autoOptInSMS: false,
      bookOnlineDiscount: 0,
      completeMoveinURL: "",
      enquiryAPI: {
        numOptions: 3,
      },
      facilitySelfService: {
        boxshop: {
          background:
            "https://ik.imagekit.io/bytcx9plm/facility-self-service-default-boxshop.png",
        },
        enquiries: {
          background:
            "https://ik.imagekit.io/bytcx9plm/facility-self-service-default-enquiries.png",
        },
        moveOut: {
          background:
            "https://ik.imagekit.io/bytcx9plm/facility-self-service-default-moveout.png",
        },
        takePayment: {
          background:
            "https://ik.imagekit.io/bytcx9plm/facility-self-service-default-take-payment.png",
        },
      },
      features: {
        boxshop: "standard",
        "facility-self-service": "standard",
        "facility-staff-self-service": "standard",
        "movein-wizard": "single-page",
        "reservation-with-fee-wizard": "standard",
        "tenant-accounts": "standard",
        "tiered-unit-listing": "standard",
        "unit-listing": "standard",
        "carousel-unit-listing": "standard",
      },
      forceTaxInclusive: false,
      hidePrices: false,
      insuranceCustomFormat: "",
      language: {
        selectionOption: "auto-detect",
      },
      moveinHideACP: false,
      notificationsAdditionalCCAddresses: [],
      payLaterButtonText: "Pay Later",
      payNowButtonText: "Pay Now",
      paymentGateways: {
        gatewayToUse: "",
        paygate: {
          countryCode: "",
          currency: "",
          encryptionKey: "",
          locale: "",
          payMethod: "",
          paygateId: "",
        },
        paynamics: {
          countryCode: "PH",
          currency: "",
          merchantId: "",
          merchantKey: "",
          merchantTermsUrl: "",
          paymentMethods: ["cc", "bn", "gc", "pp", "dp"],
          secure3d: "try3d",
        },
        paypal: {
          clientId: "",
          clientSecret: "",
          currency: "",
          useTestEnv: false,
          force3dsCheck: false,
        },
        paytabs: {
          countryCode: "",
          merchantEmail: "",
          merchantSiteUrl: "",
          messageLanguage: "",
          secretKey: "",
          merchantId: "",
        },
        use: false,
        bypassSitelinkProcessing: false,
        r6Pay: {
          currency: "",
          useTestEnv: false,
          accessToken: "",
        },
      },
      reservationExpireReservationDays: 30,
      showAutobillTerms: false,
      showPricesButtonText: "Show Prices",
      showPricesShowNeeded: true,
      showVehicleQuickSearch: false,
      showWeeklyRates: false,
      siteLinkLeaseFields: [],
      sitelinkCostRetrieveChargeNameSubstiutions: [],
      tieredPricing: {
        cherryPickBasis: "lowestRate",
        hidePrices: false,
        hideQuickSearch: false,
        noAvailableUnitsText: "Call for Availability",
        showPricesShowNeeded: true,
        showTiersWithNoAvailableUnits: true,
        showVehicleQuickSearch: false,
        showAvailableUnitsCount: false,
      },
      useBoxShopCoupons: false,
      useDealCoupons: false,
      useWebRates: false,
      wizards: {
        moveinSingle: {
          allowSelfInsurance: false,
          hideAlternativeContact: false,
          hideBoxshop: true,
          hideDateOfBirth: true,
          hideDriversLicence: false,
          hideDriversLicenceState: true,
          hideInsurance: false,
          hidePostalCode: false,
          hideState: false,
          insuranceManualEntry: false,
          insuranceRequired: false,
          requireAlternativeContactPhoneNumberField: true,
          hideInsurancePicker: false,
          allowIdUpload: false,
          allowProofOfAddressUpload: false,
          allowProofOfInsuranceUpload: false,
          insuranceAcceptancePopoverText: "",
          insuranceAcceptanceText:
            "By ticking this box you accept and agree; that the insurance coverage option selected will cover the true replacement value of your goods declared, agree to the T&C’s below and understand the inclusions/exclusions of the policy.",
          insuranceContent: "",
          insuranceContentPopoverText: "",
          insuranceManualEntryRequired: false,
          insuranceRefusedPopoverText: "",
          insuranceRefusedText:
            "By ticking this box, you are choosing not to be covered by insurance and acknowledge that we will not be held responsible for any damaged or lost goods during your rental period.",
        },
        moveinStandard: {
          requireAlternativeContactPhoneNumberField: true,
        },
        reservationWithFeeStandard: {},
      },
      checkForExistingTenant: false,
      dateFormat: "yyyy-MM-dd",
      eSignReturnUrl: "",
      locationPageUrl: "",
      moveinEmailSubject: "",
      moveinRedirectUrl: "",
      notificationsAdditionalBCCAddresses: [],
      recaptcha: {
        enabled: false,
        secretKey: "",
        siteKey: "",
        tolerance: 0.5,
      },
      reservationEmailSubject: "",
      reservationPopupText: "",
      scheduleFollowUpEmails: false,
      showAreaInsteadOfDimensions: false,
      spaceCalculatorValues: {
        bedroom: 4,
        box: 0.05,
        garage: 7,
        highestValue: {
          area: 20,
          high: 30,
          low: 18,
        },
        largeItem: 1.5,
        largeRoom: 5,
        lowestValue: {
          area: 3,
          high: 5,
          low: 1,
        },
        room: 4,
        smallItem: 0.5,
        smallRoom: 3,
      },
      useDescriptorTitle: false,
      webhooks: {
        moveIn: {
          enabled: false,
          template: "",
          url: "",
        },
        pageLoad: {
          enabled: false,
          template: "",
          url: "",
        },
        reservation: {
          enabled: false,
          template: "",
          url: "",
        },
        reservationWithFee: {
          enabled: false,
          template: "",
          url: "",
        },
        docUpload: {
          enabled: false,
          template: "",
          url: "",
        },
        enquiry: {
          enabled: false,
          template: "",
          url: "",
        },
        leadFollowUp: {
          enabled: false,
          template: "",
          url: "",
        },
      },
      autoESignRedirect: false,
      boxshopPurchaseAttachmentName: "",
      boxshopPurchaseEmailSubject: "",
      currency: "AUD",
      notificationsReplyAddress: "",
      reservationExpireOccupancyValues: {
        bands: [
          {
            from: 0,
            to: 100,
            days: 30,
          },
        ],
        enabled: false,
      },
      tenantAccounts: {
        autoPayment: {
          enabled: true,
        },
        invoiceHistory: {
          enabled: true,
        },
        makePayment: {
          enabled: true,
        },
        paymentHistory: {
          enabled: true,
        },
        tenantInfo: {
          enabled: true,
        },
        uploadIdentification: {
          enabled: true,
        },
        enableMultiSiteLogin: {
          enabled: false,
        },
        notification: {
          enabled: false,
          content: null,
          ctaButton: {
            text: null,
          },
        },
        uploadDocuments: {
          enabled: true,
          generalContent:
            "Please select & upload the following documents as a pdf or image.",
          proofOfAddress: {
            content:
              "Please upload a photo which has proof of your current address. Examples are bank statement, credit card statement or utility bill.",
            enabled: true,
            label: "Proof of Address",
          },
          proofOfId: {
            content:
              "Please upload a photo of one of your identity documents such as your Driver's Licence or National Identity Card in JPG format.",
            enabled: true,
            label: "Proof of Identification",
          },
          proofOfInsurance: {
            content:
              "Please upload a document which has proof of you being insured for your declared amount.",
            enabled: true,
            label: "Proof of Insurance",
          },
        },
      },
      allowSaveQuote: false,
      allowReservationsWhenNoAvailability: false,
      attachInsuranceDocsToMoveInConfirmationEmail: false,
      boxshopCategoryAlphaOrder: false,
      boxshopTermsConditions: "",
      datesClosed: "",
      delayedInsurance: {
        enabled: false,
        timings: {
          days: null,
          hours: null,
          minutes: null,
        },
      },
      directDebit: {
        enabled: false,
        creditAmount: 0,
      },
      documentVerification: {
        enabled: false,
        providerToUse: null,
        providers: {
          rapidId: {
            label: "RapidID",
            token: null,
          },
        },
      },
      emailSchedules: {
        quoteEmail: {
          1: {
            subject: null,
          },
          2: {
            subject: null,
            days: null,
            hours: null,
            minutes: null,
          },
          3: {
            subject: null,
            days: null,
            hours: null,
            minutes: null,
          },
        },
        quoteUnlockFirstReminder: {
          days: null,
          hours: null,
          minutes: null,
        },
        quoteUnlockSecondReminder: {
          days: null,
          hours: null,
          minutes: null,
        },
        reservationNotMovedIn: {
          days: null,
          hours: null,
          mintues: null,
        },
      },
      eSignInsuranceForm: {
        sFormName: null,
      },
      eSignInsuranceFormName: "",
      eSignMoveInDocumentNames: [],
      eSignMoveInDocuments: [],
      includeFutureMoveOut: false,
      includeReservedUnitsInOccupied: true,
      insuranceEsignReturnUrl: "",
      insurancePolicyNumberRange: {
        end: null,
        start: null,
      },
      insurancePolicyNumberRefreshNum: null,
      insuranceSmsFollowUpContent: "",
      kioskUnitListing: "standard",
      legacyPickupLocations: null,
      notificationsFromName: "",
      pickupEnabled: true,
      saveQuoteButtonText: "Save My Quote",
      requireAutobill: false,
      saveQuotePopupText: "",
      resetPasswordUrl: "",
      sendReservationEmailOnFeeFailure: false,
      shippingInventoryItem: null,
      showMoveInDateLimitMessage: false,
      siteOpeningDate: null,
      twilio: {
        accountSid: "",
        authToken: "",
        enabled: false,
        senderId: "",
      },
      useESignForInsuranceDocs: false,
      ccSiteEmailInSaveQuote: true,
      creditCardForAutobill: {
        enabled: true,
      },
      showPricesCreatesLead: false,
    },
    ownerId: "11",
    languageId: "1",
    divisionId: "11",
    hours: {
      officeMondayOpen: "9:00am",
      officeTuesdayOpen: "9:00am",
      officeWednesdayOpen: "9:00am",
      officeThursdayOpen: "9:00am",
      officeFridayOpen: "9:00am",
      officeSaturdayOpen: "9:00am",
      officeSundayOpen: "CLOSED",
      gateOpen: "24",
      officeMondayClose: "5:00pm",
      officeTuesdayClose: "5:00pm",
      officeWednesdayClose: "5:00pm",
      officeThursdayClose: "5:00pm",
      officeFridayClose: "5:00pm",
      officeSaturdayClose: "2:00pm",
      officeSundayClose: "",
      gateClose: "Hours",
      gateOpenWeekend: "24/7",
      gateCloseWeekend: "",
      gateCloseSaturday: "Hours",
      gateCloseSunday: "Hours",
      gateOpenSaturday: "24",
      gateOpenSunday: "24",
    },
    skin: {
      accentColours: {
        primary: "#25364e",
      },
      mainColour: "#496B9B",
      highlightColour: "#dddddd",
      themeColour: "#496B9B",
      moveinTimeRemaining: false,
      defaultUnitPicture: "https://ik.imagekit.io/bytcx9plm/3x3_f.png",
    },
    fees: {
      moveOutNotice: 7,
      lateDays: 3,
      lateFee: 20,
      adminFee: 49,
      nsfFee: 15,
      cleaningFee: 40,
      securityDeposit: 0,
    },
    DivisionID: "11",
    LanguageID: "1",
    OwnerID: "11",
    Ret_Code: "-97",
    Ret_Msg: "Invalid location code",
    friendlyName: null,
    pdfFonts: {
      lease: "Arial",
      insuranceDocs: "Arial",
      receipt: "Arial",
    },
  },
  {
    SiteID: 25458,
    sLocationCode: "L002",
    __v: 0,
    sGlobalSiteNum: "25458",
    iRegionalOptions: 1,
    iGMTTimeOffset: 8,
    sContactName: "Vanessa Turco",
    sEmailAddress: "oconnor@keepsafestorage.com.au",
    sSiteName: "KeepSafe Storage O'Connor",
    sSiteAddr1: "5 McNeece Place",
    sSiteCity: "O'Connor",
    sSiteRegion: "WA",
    sSitePostalCode: "6163",
    sSiteCountry: "AUS",
    sSitePhone: "08 9200 2252",
    bUseInclusiveTaxation: true,
    sTaxNumber: "44 648 410 655",
    dUpdated: "2024-05-18T16:01:07.207Z",
    uTS: "AAAAABA4vfo=",
    rapidstorEnabled: true,
    iMobileType: "0",
    iOnLineChargeType: "0",
    sSiteFAX: "08 9331 3715",
    sWebSiteURL: "www.keepsafestorage.com.au",
    iFeatMaxUnits: "750",
    bFeatGate: "true",
    bFeatKiosk: "true",
    bFeatRevMgmt: "true",
    bFeatCreditCards: "true",
    bFeatCorpOffice: "true",
    bFeatAccounting: "true",
    bFeatRecordStorage: "false",
    bFeatACH: "true",
    bFeatMobileStorage: "false",
    bFeatPromoAdvanced: "false",
    dACHStatus: "2015-06-22T09:23:28.253-04:00",
    bLiteVersion: "false",
    bTrial: "false",
    bSubscription: "false",
    bSiteDisabled: "false",
    dGateUpdated: "2024-05-13T09:01:45.037-04:00",
    dOvernightProcess: "2024-05-18T12:01:07.207-04:00",
    sLegalName: "BDST OPCO PTY LTD",
    bZipCodeData_Use: "false",
    dcLongitude: "115.7929270000",
    dcLatitude: "-32.0590540000",
    bClosedWeekdays: "false",
    bClosedSaturday: "false",
    bClosedSunday: "true",
    dWeekdayStrt: "2008-07-02T08:30:00-04:00",
    dWeekdayEnd: "2008-07-02T17:30:00-04:00",
    dSaturdayStrt: "2008-07-02T08:30:00-04:00",
    dSaturdayEnd: "2008-07-02T17:30:00-04:00",
    dSundayStrt: "2008-07-02T05:00:00-04:00",
    dSundayEnd: "2008-07-02T21:00:00-04:00",
    iIdentifier: "0",
    iBusinessType: "-32",
    iSiteDataType: "0",
    iFacilityUsage: "0",
    iFacilityOwnership: "0",
    iFacilityMgmt: "0",
    iFacilityLocType: "0",
    iMobileBungoRules: "0",
    iOnLinePmtsAllowed: "1",
    iEdition: "1",
    iTerminalServices: "0",
    iDST: "0",
    dCreated: "2015-01-30T12:58:49.46-05:00",
    bPermanent: "false",
    bArchived: "false",
    iVerboseLogging: "0",
    iSiteLinkStoreTier: "1",
    sSLBillingRef: "DQS002",
    iSubscriptionType: "0",
    tWeekdayStrt: "08:30:00",
    tWeekdayEnd: "17:30:00",
    tSaturdayStrt: "08:30:00",
    tSaturdayEnd: "17:30:00",
    tSundayStrt: "05:00:00",
    tSundayEnd: "21:00:00",
    sLocationDesc: null,
    sSiteIDCode: null,
    sSiteRegionCode: null,
    sSiteAddr2: null,
    sIdentifier: null,
    bForcePushRates: "1",
    iWebRatesType: "0",
    token:
      "39ec699d72984e9466a21cb9accb1ffaaf306379a8872d07d465ca99e8c6df6e8a8589b96e4839931f9138a2ad838ee9",
    changedAt: "2024-05-19T07:33:15.894Z",
    changeToken:
      "98a16dcadd0ab2c4fafb069c5e6077aacd425ea4e52ad6927f19273a0d7c7bc813ee57212261780e6ef7b429b71aae54",
    deleted: false,
    administrative: {
      boxshopEnabled: true,
      testMode: false,
      rslite: false,
      rsliteKey: "N/A",
      refreshEnabled: false,
      availableForUse: false,
      insuranceEnabled: false,
      merchEnabled: false,
      carouselListing: false,
      useMtasForAuth: false,
    },
    rapidstor: {
      pushRate: true,
      siteLogo:
        "https://ik.imagekit.io/bytcx9plm/CDQS-L002-logo-cjilmq7nb01ebhfd6z2f51mux.png",
      marketingSurvey: {
        use: true,
        questions: {
          whereHearAboutUs: {
            display: true,
            required: true,
          },
          distanceFromFacility: {
            display: true,
            required: true,
          },
          whyStoring: {
            display: true,
            required: true,
          },
          customerType: {
            display: true,
            required: true,
          },
          whatStoring: {
            display: true,
            required: true,
          },
          whyStoringWithUs: {
            display: true,
            required: true,
          },
        },
      },
      country: "AU",
      unitListing: {
        sortOrder: {
          primary: "size",
          secondary: "price",
          tertiary: "availability",
        },
        useMultilevel: true,
      },
      allowOriginUrl: [
        "https://keepsafestorage.com.au",
        "https://keepsafestoragecomau.r6d.dev",
      ],
      allowedCreditCardTypes: {
        visa: true,
        mastercard: true,
        amex: false,
      },
      facilitySelfService: {
        enquiries: {
          background:
            "https://ik.imagekit.io/bytcx9plm/facility-self-service-default-enquiries.png",
        },
        takePayment: {
          background:
            "https://ik.imagekit.io/bytcx9plm/facility-self-service-default-take-payment.png",
        },
        moveOut: {
          background:
            "https://ik.imagekit.io/bytcx9plm/facility-self-service-default-moveout.png",
        },
        boxshop: {
          background:
            "https://ik.imagekit.io/bytcx9plm/facility-self-service-default-boxshop.png",
        },
      },
      tieredPricing: {
        showTiersWithNoAvailableUnits: true,
        noAvailableUnitsText: "Call for Availability",
        cherryPickBasis: "lowestRate",
        hidePrices: false,
        hideQuickSearch: false,
        showPricesShowNeeded: true,
        showVehicleQuickSearch: false,
        showAvailableUnitsCount: false,
      },
      language: {
        selectionOption: "auto-detect",
      },
      useBoxShopCoupons: false,
      useDealCoupons: false,
      siteLinkLeaseFields: [],
      wizards: {
        moveinUse: "movein_standard",
        reservationWithFeeUse: "reservation_with_fee_standard",
        moveinSingle: {
          hideAlternativeContact: false,
          hideBoxshop: false,
          hideInsurance: false,
          insuranceRequired: false,
          hideDriversLicence: false,
          hideDriversLicenceState: true,
          hideDateOfBirth: false,
          hideState: false,
          hidePostalCode: false,
          allowSelfInsurance: false,
          insuranceManualEntry: false,
          requireAlternativeContactPhoneNumberField: true,
          hideInsurancePicker: false,
          allowIdUpload: true,
          allowProofOfAddressUpload: false,
          allowProofOfInsuranceUpload: false,
          insuranceAcceptancePopoverText: "",
          insuranceAcceptanceText:
            "By ticking this box you accept and agree; that the insurance coverage option selected will cover the true replacement value of your goods declared, agree to the T&C’s below and understand the inclusions/exclusions of the policy.",
          insuranceContent: "",
          insuranceContentPopoverText: "",
          insuranceManualEntryRequired: false,
          insuranceRefusedPopoverText: "",
          insuranceRefusedText:
            "By ticking this box, you are choosing not to be covered by insurance and acknowledge that we will not be held responsible for any damaged or lost goods during your rental period.",
        },
        moveinStandard: {
          requireAlternativeContactPhoneNumberField: true,
        },
        reservationWithFeeStandard: {},
      },
      features: {
        "movein-wizard": "single-page",
        "unit-listing": "modern",
        boxshop: "standard",
        "reservation-with-fee-wizard": "standard",
        "tiered-unit-listing": "standard",
        "facility-self-service": "standard",
        "facility-staff-self-service": "standard",
        "tenant-accounts": "standard",
        "carousel-unit-listing": "standard",
      },
      paymentGateways: {
        use: false,
        gatewayToUse: "",
        paypal: {
          currency: "",
          clientId: "",
          clientSecret: "",
          useTestEnv: false,
          force3dsCheck: false,
        },
        paytabs: {
          merchantEmail: "",
          secretKey: "",
          merchantSiteUrl: "",
          countryCode: "",
          messageLanguage: "",
          merchantId: "",
        },
        paygate: {
          countryCode: "",
          currency: "",
          encryptionKey: "",
          locale: "",
          payMethod: "",
          paygateId: "",
        },
        paynamics: {
          countryCode: "PH",
          currency: "",
          merchantId: "",
          merchantKey: "",
          merchantTermsUrl: "",
          paymentMethods: ["cc", "bn", "gc", "pp", "dp"],
          secure3d: "try3d",
        },
        bypassSitelinkProcessing: false,
        r6Pay: {
          currency: "",
          useTestEnv: false,
          accessToken: "",
        },
      },
      smallMediumSize: 8,
      mediumLargeSize: 14,
      moveinHideAcp: false,
      hideBoxshop: false,
      currencySymbol: "$",
      shippingEnabled: false,
      billingDefault: "MonthlyAnniversary",
      sizeSymbol: "m",
      allowReservation: false,
      allowMoveIn: true,
      minAvailableUnits: 0,
      hideUnitsMinAvailable: false,
      noAvailableUnitsText: "Call for Availability",
      hideQuickSearch: false,
      insuranceRequired: false,
      hideInsurance: false,
      hideLicense: false,
      hideLicenseState: true,
      hideDateOfBirth: true,
      hideState: false,
      hidePostalCode: false,
      autoOptInSms: false,
      groundFloor: 0,
      legacyPickupLocationsEnabled: false,
      freeShippingDealEnabled: false,
      freeShippingDealAmount: 150,
      reservationNumberOfDaysInAdvanceLimit: 7,
      moveinNumberOfDaysInAdvanceLimit: 14,
      reservationNumberOfDaysInAdvanceChargeFee: 0,
      assistanceMoving: false,
      assistanceMovingEmailAddress: "",
      notificationsFromAddress: "oconnor@keepsafestorage.com.au",
      completeMoveinUrl: "",
      useESign: true,
      useAutoBilling: true,
      autoBillCheckedByDefault: false,
      doNotSendInvoiceSiteLinkWhenAutoBill: false,
      quickReserveButtonText: "Quick Reserve",
      reservationExpireReservationDays: "14",
      notificationsAdditionalCcAddresses: [],
      showVehicleQuickSearch: false,
      areaSizeSymbol: "m²",
      attachLeaseToMoveInConfirmationEmail: false,
      attachReceiptToMoveInConfirmationEmail: true,
      autoOptInSMS: false,
      bookOnlineDiscount: 0,
      completeMoveinURL: "",
      enquiryAPI: {
        numOptions: 3,
      },
      forceTaxInclusive: false,
      hidePrices: false,
      insuranceCustomFormat: "",
      moveinHideACP: false,
      notificationsAdditionalCCAddresses: [],
      payLaterButtonText: "Proceed",
      payNowButtonText: "Pay Now",
      showAutobillTerms: false,
      showPricesButtonText: "Show Prices",
      showPricesShowNeeded: true,
      showWeeklyRates: false,
      sitelinkCostRetrieveChargeNameSubstiutions: [],
      useWebRates: false,
      checkForExistingTenant: false,
      dateFormat: "dd-MM-yyyy",
      eSignReturnUrl: "https://keepsafestorage.com.au/booking-confirmation/",
      locationPageUrl: "",
      moveinEmailSubject: "",
      moveinRedirectUrl:
        "https://keepsafestorage.com.au/book-a-unit/locations/o-connor/book-confirmed",
      notificationsAdditionalBCCAddresses: [],
      recaptcha: {
        enabled: true,
        secretKey: "6Lf5GTwoAAAAAOvne7oKNDKEOmGBpxPkkjeS927u",
        siteKey: "6Lf5GTwoAAAAACOg3xVeVHJlt9MiGuzR7MI48VgM",
        tolerance: 0.5,
      },
      reservationEmailSubject: "",
      reservationPopupText: "",
      scheduleFollowUpEmails: true,
      showAreaInsteadOfDimensions: false,
      spaceCalculatorValues: {
        bedroom: 4,
        box: 0.05,
        garage: 7,
        highestValue: {
          area: 20,
          high: 30,
          low: 18,
        },
        largeItem: 1.5,
        largeRoom: 5,
        lowestValue: {
          area: 3,
          high: 5,
          low: 1,
        },
        room: 4,
        smallItem: 0.5,
        smallRoom: 3,
      },
      useDescriptorTitle: false,
      webhooks: {
        moveIn: {
          enabled: false,
          template: "",
          url: "",
        },
        pageLoad: {
          enabled: false,
          template: "",
          url: "",
        },
        reservation: {
          enabled: false,
          template: "",
          url: "",
        },
        reservationWithFee: {
          enabled: false,
          template: "",
          url: "",
        },
        docUpload: {
          enabled: false,
          template: "",
          url: "",
        },
        leadFollowUp: {
          enabled: false,
          template: "",
          url: "",
        },
        enquiry: {
          enabled: false,
          template: "",
          url: "",
        },
      },
      currency: "AUD",
      autoESignRedirect: true,
      boxshopPurchaseAttachmentName: "",
      boxshopPurchaseEmailSubject: "",
      notificationsReplyAddress: "",
      reservationExpireOccupancyValues: {
        bands: [
          {
            from: 0,
            to: 100,
            days: 30,
          },
        ],
        enabled: false,
      },
      tenantAccounts: {
        autoPayment: {
          enabled: true,
        },
        invoiceHistory: {
          enabled: true,
        },
        makePayment: {
          enabled: true,
        },
        paymentHistory: {
          enabled: true,
        },
        tenantInfo: {
          enabled: true,
        },
        uploadIdentification: {
          enabled: true,
        },
        uploadDocuments: {
          enabled: true,
          generalContent:
            "Please select & upload the following documents as a pdf or image.",
          proofOfAddress: {
            content:
              "Please upload a photo which has proof of your current address. Examples are bank statement, credit card statement or utility bill.",
            enabled: true,
            label: "Proof of Address",
          },
          proofOfId: {
            content:
              "Please upload a photo of one of your identity documents such as your Driver's Licence or National Identity Card in JPG format.",
            enabled: true,
            label: "Proof of Identification",
          },
          proofOfInsurance: {
            content:
              "Please upload a document which has proof of you being insured for your declared amount.",
            enabled: true,
            label: "Proof of Insurance",
          },
        },
        notification: {
          content: null,
          ctaButton: {
            text: null,
          },
          enabled: false,
        },
        enableMultiSiteLogin: {
          enabled: false,
        },
      },
      allowReservationsWhenNoAvailability: false,
      boxshopCategoryAlphaOrder: false,
      boxshopTermsConditions: "",
      datesClosed: "",
      eSignInsuranceFormName: "",
      eSignMoveInDocumentNames: [],
      eSignMoveInDocuments: [],
      includeFutureMoveOut: false,
      includeReservedUnitsInOccupied: true,
      insuranceEsignReturnUrl: "",
      pickupEnabled: true,
      resetPasswordUrl: "",
      showMoveInDateLimitMessage: false,
      useESignForInsuranceDocs: false,
      eSignInsuranceForm: {
        sFormName: null,
      },
      emailSchedules: {
        quoteUnlockFirstReminder: {
          days: null,
          hours: null,
          mintues: null,
          minutes: null,
        },
        quoteUnlockSecondReminder: {
          days: null,
          hours: null,
          mintues: null,
          minutes: null,
        },
        reservationNotMovedIn: {
          days: 0,
          hours: 0,
          mintues: null,
          minutes: 20,
        },
        quoteEmail: {
          1: {
            subject: "Your Storage Quote",
          },
          2: {
            days: 0,
            hours: 0,
            minutes: 0,
            subject: "Did you forget something?",
          },
          3: {
            days: 0,
            hours: 0,
            minutes: 0,
            subject: "Don't miss out!",
          },
        },
      },
      insurancePolicyNumberRange: {
        end: null,
        start: null,
      },
      insurancePolicyNumberRefreshNum: null,
      kioskUnitListing: "standard",
      legacyPickupLocations: null,
      notificationsFromName: "Keepsafe Storage",
      shippingInventoryItem: null,
      siteOpeningDate: null,
      attachInsuranceDocsToMoveInConfirmationEmail: false,
      delayedInsurance: {
        enabled: false,
        timings: {
          days: null,
          hours: null,
          minutes: null,
        },
      },
      documentVerification: {
        enabled: false,
        providerToUse: null,
        providers: {
          rapidId: {
            label: "RapidID",
            token: null,
          },
        },
      },
      insuranceSmsFollowUpContent: "",
      twilio: {
        accountSid: "",
        authToken: "",
        enabled: false,
        senderId: "",
      },
      directDebit: {
        creditAmount: 0,
        enabled: false,
      },
      requireAutobill: false,
      sendReservationEmailOnFeeFailure: false,
      allowSaveQuote: true,
      saveQuoteButtonText: "Save My Quote",
      saveQuotePopupText: "",
      ccSiteEmailInSaveQuote: false,
      creditCardForAutobill: {
        enabled: true,
      },
      showPricesCreatesLead: false,
    },
    hours: {
      officeMondayOpen: "9.00am",
      officeTuesdayOpen: "9.00am",
      officeWednesdayOpen: "9.00am",
      officeThursdayOpen: "9.00am",
      officeFridayOpen: "9.00am",
      officeSaturdayOpen: "9.00am",
      officeSundayOpen: "Closed",
      gateOpen: "24",
      officeMondayClose: "5:00pm",
      officeTuesdayClose: "5:00pm",
      officeWednesdayClose: "5:00pm",
      officeThursdayClose: "5:00pm",
      officeFridayClose: "5:00pm",
      officeSaturdayClose: "2:00pm",
      officeSundayClose: "",
      gateClose: "Hours",
      gateOpenWeekend: "9:00am",
      gateCloseWeekend: "5:00pm",
      gateCloseSaturday: "Hours",
      gateCloseSunday: "Hours",
      gateOpenSaturday: "24",
      gateOpenSunday: "24",
    },
    skin: {
      accentColours: {
        primary: "#701605",
      },
      defaultUnitPicture: "https://ik.imagekit.io/bytcx9plm/3x3_f.png",
      mainColour: "#e02b0a",
      highlightColour: "#dddddd",
      themeColour: "#e02b0a",
      moveinTimeRemaining: false,
    },
    fees: {
      moveOutNotice: 7,
      lateDays: 15,
      lateFee: 20,
      adminFee: 49,
      nsfFee: 15,
      cleaningFee: 40,
      securityDeposit: 0,
    },
    ownerId: "11",
    languageId: "1",
    divisionId: "11",
    DivisionID: "11",
    LanguageID: "1",
    OwnerID: "11",
    pdfFonts: {
      lease: "Arial",
      receipt: "Arial",
      insuranceDocs: "Arial",
    },
    scaConfiguration: {},
    collections: {
      unitsFull: {
        name: "unitsFull",
        job: "CDQS/L002/unitsFull",
        status: "finished",
        timestamp: 1715992228911,
      },
      unitTypeGroup: {
        name: "unitTypeGroup",
        job: "CDQS/L002/unitTypeGroup",
        status: "finished",
        timestamp: 1715992228911,
      },
      discountPlan: {
        name: "discountPlan",
        job: "CDQS/L002/discountPlan",
        status: "finished",
        timestamp: 1715992228912,
      },
      chargeDescription: {
        name: "chargeDescription",
        job: "CDQS/L002/chargeDescription",
        status: "finished",
        timestamp: 1715992228912,
      },
      site: {
        name: "site",
        job: "CDQS/L002/site",
        status: "finished",
        timestamp: 1715992228912,
      },
      form: {
        name: "form",
        job: "CDQS/L002/form",
        status: "finished",
        timestamp: 1715992228912,
      },
      insuranceCoverage: {
        name: "insuranceCoverage",
        job: "CDQS/L002/insuranceCoverage",
        status: "finished",
        timestamp: 1715992228912,
      },
      inventory: {
        name: "inventory",
        job: "CDQS/L002/inventory",
        status: "finished",
        timestamp: 1715992228912,
      },
      paymentTypes: {
        name: "paymentTypes",
        job: "CDQS/L002/paymentTypes",
        status: "finished",
        timestamp: 1715992228912,
      },
      marketingSource: {
        name: "marketingSource",
        job: "CDQS/L002/marketingSource",
        status: "finished",
        timestamp: 1715992228912,
      },
      paymentSettings: {
        name: "paymentSettings",
        job: "CDQS/L002/paymentSettings",
        status: "finished",
        timestamp: 1715992228912,
      },
    },
    friendlyName: null,
    originalName: "KeepSafe Storage O'Connor",
    personas: [],
    sCorpCode: "CDQS",
  },
  {
    SiteID: 27518,
    sLocationCode: "L003",
    __v: 0,
    sGlobalSiteNum: "27518",
    iRegionalOptions: 1,
    iGMTTimeOffset: 8,
    sContactName: "Graham Moffitt",
    sEmailAddress: "balcatta@keepsafestorage.com.au",
    sSiteName: "KeepSafe Storage Balcatta",
    sSiteAddr1: "46 Ledgar Rd",
    sSiteCity: "Balcatta",
    sSiteRegion: "WA",
    sSitePostalCode: "6021",
    sSiteCountry: "AUS",
    sSitePhone: "08 9200 6252",
    bUseInclusiveTaxation: true,
    sTaxNumber: "44648410655",
    dUpdated: "2024-05-19T16:04:03.390Z",
    uTS: "AAAAABA5RKs=",
    rapidstorEnabled: true,
    iMobileType: "0",
    iOnLineChargeType: "0",
    sLocationDesc: "Located at the corner of Balcatta Rd and Ledgar Rd Balcatta",
    sSiteFAX: ".",
    sWebSiteURL: "http://www.keepsafestorage.com.au",
    iFeatMaxUnits: "750",
    bFeatGate: "true",
    bFeatKiosk: "true",
    bFeatRevMgmt: "true",
    bFeatCreditCards: "true",
    bFeatCorpOffice: "true",
    bFeatAccounting: "true",
    bFeatRecordStorage: "false",
    bFeatACH: "true",
    bFeatMobileStorage: "false",
    bFeatPromoAdvanced: "false",
    dACHStatus: "2015-11-30T18:08:10.557-05:00",
    bLiteVersion: "false",
    bTrial: "false",
    bSubscription: "false",
    bSiteDisabled: "false",
    dGateUpdated: "2024-05-02T11:33:44.483-04:00",
    dOvernightProcess: "2024-05-19T12:04:03.39-04:00",
    sLegalName: "BDST OPCO PTY LTD",
    bZipCodeData_Use: "false",
    dcLongitude: "115.8029140000",
    dcLatitude: "-31.8598660000",
    bClosedWeekdays: "false",
    bClosedSaturday: "false",
    bClosedSunday: "true",
    dWeekdayStrt: "2011-01-06T08:30:00-05:00",
    dWeekdayEnd: "2011-01-06T17:30:59-05:00",
    dSaturdayStrt: "2011-01-06T08:30:00-05:00",
    dSaturdayEnd: "2011-01-06T17:30:59-05:00",
    dSundayStrt: "2011-01-06T09:00:00-05:00",
    dSundayEnd: "2011-01-06T17:30:59-05:00",
    iIdentifier: "0",
    iBusinessType: "-32",
    iSiteDataType: "0",
    iFacilityUsage: "0",
    iFacilityOwnership: "0",
    iFacilityMgmt: "0",
    iFacilityLocType: "0",
    iMobileBungoRules: "0",
    iOnLinePmtsAllowed: "1",
    iEdition: "1",
    iTerminalServices: "0",
    iDST: "0",
    dCreated: "2015-11-30T18:08:07.84-05:00",
    bPermanent: "false",
    bArchived: "false",
    iVerboseLogging: "0",
    iSiteLinkStoreTier: "1",
    sSLBillingRef: "DQS003",
    iSubscriptionType: "0",
    tWeekdayStrt: "08:30:00",
    tWeekdayEnd: "17:30:59",
    tSaturdayStrt: "08:30:00",
    tSaturdayEnd: "17:30:59",
    tSundayStrt: "09:00:00",
    tSundayEnd: "17:30:59",
    sSiteIDCode: null,
    sSiteRegionCode: null,
    sSiteAddr2: null,
    sIdentifier: null,
    bForcePushRates: "0",
    iWebRatesType: "0",
    token:
      "18c144d49a3a0d56a9a3510c8b2a454a7f3155d6df443fcf2701d807343c59d0b4893c1b32546ba61778d709a03641d9",
    changedAt: "2024-05-19T20:26:29.670Z",
    changeToken:
      "04ddcee426f45958f9e187147db930d9892f90b6fa43cb0aa4d724555652b36c4160b66a0de6f4d57b6903ce804ae944",
    deleted: false,
    administrative: {
      boxshopEnabled: true,
      testMode: false,
      rslite: false,
      rsliteKey: "N/A",
      refreshEnabled: false,
      availableForUse: false,
      insuranceEnabled: false,
      merchEnabled: false,
      carouselListing: false,
      useMtasForAuth: false,
    },
    rapidstor: {
      pushRate: true,
      maxBeforeRes: false,
      maxFutureBookable: false,
      minUnitsReq: false,
      siteLogo:
        "https://ik.imagekit.io/bytcx9plm/CDQS-L003-logo-cjilmq91d01ehhfd6x6z6d3nd.png",
      marketingSurvey: {
        use: true,
        questions: {
          whereHearAboutUs: {
            display: true,
            required: true,
          },
          distanceFromFacility: {
            display: true,
            required: true,
          },
          whyStoring: {
            display: true,
            required: true,
          },
          customerType: {
            display: true,
            required: true,
          },
          whatStoring: {
            display: true,
            required: true,
          },
          whyStoringWithUs: {
            display: true,
            required: true,
          },
        },
      },
      country: "AU",
      unitListing: {
        sortOrder: {
          primary: "size",
          secondary: "price",
          tertiary: "availability",
        },
        useMultilevel: true,
      },
      allowOriginUrl: ["https://keepsafestorage.com.au"],
      allowedCreditCardTypes: {
        visa: true,
        mastercard: true,
        amex: false,
      },
      facilitySelfService: {
        enquiries: {
          background:
            "https://ik.imagekit.io/bytcx9plm/facility-self-service-default-enquiries.png",
        },
        takePayment: {
          background:
            "https://ik.imagekit.io/bytcx9plm/facility-self-service-default-take-payment.png",
        },
        moveOut: {
          background:
            "https://ik.imagekit.io/bytcx9plm/facility-self-service-default-moveout.png",
        },
        boxshop: {
          background:
            "https://ik.imagekit.io/bytcx9plm/facility-self-service-default-boxshop.png",
        },
      },
      tieredPricing: {
        showTiersWithNoAvailableUnits: true,
        noAvailableUnitsText: "Call for Availability",
        cherryPickBasis: "lowestRate",
        hidePrices: false,
        hideQuickSearch: false,
        showPricesShowNeeded: true,
        showVehicleQuickSearch: false,
        showAvailableUnitsCount: false,
      },
      language: {
        selectionOption: "auto-detect",
      },
      useBoxShopCoupons: false,
      useDealCoupons: false,
      siteLinkLeaseFields: [],
      wizards: {
        moveinSingle: {
          hideAlternativeContact: false,
          hideBoxshop: false,
          hideInsurance: false,
          insuranceRequired: false,
          hideDriversLicence: false,
          hideDriversLicenceState: true,
          hideDateOfBirth: false,
          hideState: false,
          hidePostalCode: false,
          allowSelfInsurance: false,
          insuranceManualEntry: false,
          requireAlternativeContactPhoneNumberField: true,
          hideInsurancePicker: false,
          allowIdUpload: true,
          allowProofOfAddressUpload: false,
          allowProofOfInsuranceUpload: false,
          insuranceAcceptancePopoverText: "",
          insuranceAcceptanceText:
            "By ticking this box you accept and agree; that the insurance coverage option selected will cover the true replacement value of your goods declared, agree to the T&C’s below and understand the inclusions/exclusions of the policy.",
          insuranceContent: "",
          insuranceContentPopoverText: "",
          insuranceManualEntryRequired: false,
          insuranceRefusedPopoverText: "",
          insuranceRefusedText:
            "By ticking this box, you are choosing not to be covered by insurance and acknowledge that we will not be held responsible for any damaged or lost goods during your rental period.",
        },
        moveinStandard: {
          requireAlternativeContactPhoneNumberField: true,
        },
        reservationWithFeeStandard: {},
      },
      features: {
        "movein-wizard": "single-page",
        "unit-listing": "modern",
        boxshop: "standard",
        "reservation-with-fee-wizard": "standard",
        "tiered-unit-listing": "standard",
        "facility-self-service": "standard",
        "facility-staff-self-service": "standard",
        "tenant-accounts": "standard",
        "carousel-unit-listing": "standard",
      },
      paymentGateways: {
        use: false,
        gatewayToUse: "",
        paypal: {
          currency: "",
          clientId: "",
          clientSecret: "",
          useTestEnv: false,
          force3dsCheck: false,
        },
        paytabs: {
          merchantEmail: "",
          secretKey: "",
          merchantSiteUrl: "",
          countryCode: "",
          messageLanguage: "",
          merchantId: "",
        },
        paygate: {
          countryCode: "",
          currency: "",
          encryptionKey: "",
          locale: "",
          payMethod: "",
          paygateId: "",
        },
        paynamics: {
          countryCode: "PH",
          currency: "",
          merchantId: "",
          merchantKey: "",
          merchantTermsUrl: "",
          paymentMethods: ["cc", "bn", "gc", "pp", "dp"],
          secure3d: "try3d",
        },
        bypassSitelinkProcessing: false,
        r6Pay: {
          currency: "",
          useTestEnv: false,
          accessToken: "",
        },
      },
      billingDefault: "MonthlyAnniversary",
      smallMediumSize: 8,
      mediumLargeSize: 14,
      moveinHideAcp: false,
      hideBoxshop: false,
      currencySymbol: "$",
      shippingEnabled: false,
      sizeSymbol: "m",
      allowReservation: false,
      allowMoveIn: true,
      minAvailableUnits: 0,
      hideUnitsMinAvailable: false,
      noAvailableUnitsText: "Call for Availability",
      hideQuickSearch: false,
      insuranceRequired: false,
      hideInsurance: false,
      hideLicense: false,
      hideLicenseState: true,
      hideDateOfBirth: true,
      hideState: false,
      hidePostalCode: false,
      autoOptInSms: false,
      groundFloor: 0,
      legacyPickupLocationsEnabled: false,
      freeShippingDealEnabled: false,
      freeShippingDealAmount: 150,
      reservationNumberOfDaysInAdvanceLimit: 7,
      moveinNumberOfDaysInAdvanceLimit: 14,
      reservationNumberOfDaysInAdvanceChargeFee: 0,
      assistanceMoving: false,
      assistanceMovingEmailAddress: "",
      notificationsFromAddress: "balcatta@keepsafestorage.com.au",
      completeMoveinUrl: "",
      useESign: true,
      useAutoBilling: true,
      autoBillCheckedByDefault: false,
      doNotSendInvoiceSiteLinkWhenAutoBill: false,
      quickReserveButtonText: "Quick Reserve",
      reservationExpireReservationDays: "7",
      notificationsAdditionalCcAddresses: [],
      showVehicleQuickSearch: false,
      areaSizeSymbol: "m²",
      attachLeaseToMoveInConfirmationEmail: false,
      attachReceiptToMoveInConfirmationEmail: true,
      autoOptInSMS: false,
      bookOnlineDiscount: 0,
      completeMoveinURL: "",
      enquiryAPI: {
        numOptions: 3,
      },
      forceTaxInclusive: false,
      hidePrices: false,
      insuranceCustomFormat: "",
      moveinHideACP: false,
      notificationsAdditionalCCAddresses: [],
      payLaterButtonText: "Pay Later",
      payNowButtonText: "Pay Now",
      showAutobillTerms: false,
      showPricesButtonText: "Show Prices",
      showPricesShowNeeded: true,
      showWeeklyRates: false,
      sitelinkCostRetrieveChargeNameSubstiutions: [],
      useWebRates: false,
      checkForExistingTenant: false,
      dateFormat: "dd-MM-yyyy",
      eSignReturnUrl: "https://keepsafestorage.com.au/booking-confirmation/",
      locationPageUrl: "",
      moveinEmailSubject: "",
      moveinRedirectUrl:
        "https://keepsafestorage.com.au/book-a-unit/locations/balcatta/book-confirmed",
      notificationsAdditionalBCCAddresses: [],
      recaptcha: {
        enabled: true,
        secretKey: "6Lf5GTwoAAAAAOvne7oKNDKEOmGBpxPkkjeS927u",
        siteKey: "6Lf5GTwoAAAAACOg3xVeVHJlt9MiGuzR7MI48VgM",
        tolerance: 0.5,
      },
      reservationEmailSubject: "",
      reservationPopupText: "",
      scheduleFollowUpEmails: true,
      showAreaInsteadOfDimensions: false,
      spaceCalculatorValues: {
        bedroom: 4,
        box: 0.05,
        garage: 7,
        highestValue: {
          area: 20,
          high: 30,
          low: 18,
        },
        largeItem: 1.5,
        largeRoom: 5,
        lowestValue: {
          area: 3,
          high: 5,
          low: 1,
        },
        room: 4,
        smallItem: 0.5,
        smallRoom: 3,
      },
      useDescriptorTitle: false,
      webhooks: {
        moveIn: {
          enabled: false,
          template: "",
          url: "",
        },
        pageLoad: {
          enabled: false,
          template: "",
          url: "",
        },
        reservation: {
          enabled: false,
          template: "",
          url: "",
        },
        reservationWithFee: {
          enabled: false,
          template: "",
          url: "",
        },
        docUpload: {
          enabled: false,
          template: "",
          url: "",
        },
        leadFollowUp: {
          enabled: false,
          template: "",
          url: "",
        },
        enquiry: {
          enabled: false,
          template: "",
          url: "",
        },
      },
      currency: "AUD",
      autoESignRedirect: true,
      boxshopPurchaseAttachmentName: "",
      boxshopPurchaseEmailSubject: "",
      notificationsReplyAddress: "",
      reservationExpireOccupancyValues: {
        bands: [
          {
            from: 0,
            to: 100,
            days: 30,
          },
        ],
        enabled: false,
      },
      tenantAccounts: {
        autoPayment: {
          enabled: true,
        },
        invoiceHistory: {
          enabled: true,
        },
        makePayment: {
          enabled: true,
        },
        paymentHistory: {
          enabled: true,
        },
        tenantInfo: {
          enabled: true,
        },
        uploadIdentification: {
          enabled: true,
        },
        uploadDocuments: {
          enabled: true,
          generalContent:
            "Please select & upload the following documents as a pdf or image.",
          proofOfAddress: {
            content:
              "Please upload a photo which has proof of your current address. Examples are bank statement, credit card statement or utility bill.",
            enabled: true,
            label: "Proof of Address",
          },
          proofOfId: {
            content:
              "Please upload a photo of one of your identity documents such as your Driver's Licence or National Identity Card in JPG format.",
            enabled: true,
            label: "Proof of Identification",
          },
          proofOfInsurance: {
            content:
              "Please upload a document which has proof of you being insured for your declared amount.",
            enabled: true,
            label: "Proof of Insurance",
          },
        },
        notification: {
          content: null,
          ctaButton: {
            text: null,
          },
          enabled: false,
        },
        enableMultiSiteLogin: {
          enabled: false,
        },
      },
      allowReservationsWhenNoAvailability: false,
      boxshopCategoryAlphaOrder: false,
      boxshopTermsConditions: "",
      datesClosed: "",
      eSignInsuranceFormName: "",
      eSignMoveInDocumentNames: [],
      eSignMoveInDocuments: [],
      includeFutureMoveOut: false,
      includeReservedUnitsInOccupied: true,
      insuranceEsignReturnUrl: "",
      pickupEnabled: true,
      resetPasswordUrl: "",
      showMoveInDateLimitMessage: false,
      useESignForInsuranceDocs: false,
      eSignInsuranceForm: {
        sFormName: null,
      },
      emailSchedules: {
        quoteUnlockFirstReminder: {
          days: null,
          hours: null,
          mintues: null,
          minutes: null,
        },
        quoteUnlockSecondReminder: {
          days: null,
          hours: null,
          mintues: null,
          minutes: null,
        },
        reservationNotMovedIn: {
          days: 0,
          hours: 0,
          mintues: null,
          minutes: 20,
        },
        quoteEmail: {
          1: {
            subject: "Your Storage Quote",
          },
          2: {
            days: 0,
            hours: 0,
            minutes: 0,
            subject: "Did you forget something?",
          },
          3: {
            days: 0,
            hours: 0,
            minutes: 0,
            subject: "Don't miss out!",
          },
        },
      },
      insurancePolicyNumberRange: {
        end: null,
        start: null,
      },
      insurancePolicyNumberRefreshNum: null,
      kioskUnitListing: "standard",
      legacyPickupLocations: null,
      notificationsFromName: "Keepsafe Storage",
      shippingInventoryItem: null,
      siteOpeningDate: null,
      attachInsuranceDocsToMoveInConfirmationEmail: false,
      delayedInsurance: {
        enabled: false,
        timings: {
          days: null,
          hours: null,
          minutes: null,
        },
      },
      documentVerification: {
        enabled: false,
        providerToUse: null,
        providers: {
          rapidId: {
            label: "RapidID",
            token: null,
          },
        },
      },
      insuranceSmsFollowUpContent: "",
      twilio: {
        accountSid: "",
        authToken: "",
        enabled: false,
        senderId: "",
      },
      directDebit: {
        creditAmount: 0,
        enabled: false,
      },
      requireAutobill: false,
      sendReservationEmailOnFeeFailure: false,
      allowSaveQuote: true,
      saveQuoteButtonText: "Save My Quote",
      saveQuotePopupText: "",
      ccSiteEmailInSaveQuote: false,
      creditCardForAutobill: {
        enabled: true,
      },
      showPricesCreatesLead: false,
    },
    ownerId: "11",
    languageId: "1",
    divisionId: "11",
    hours: {
      officeMondayOpen: "9:00am",
      officeTuesdayOpen: "9:00am",
      officeWednesdayOpen: "9:00am",
      officeThursdayOpen: "9:00am",
      officeFridayOpen: "9:00am",
      officeSaturdayOpen: "9:00am",
      officeSundayOpen: "Closed",
      gateOpen: "24",
      officeMondayClose: "5:00pm",
      officeTuesdayClose: "5:00pm",
      officeWednesdayClose: "5:00pm",
      officeThursdayClose: "5:00pm",
      officeFridayClose: "5:00pm",
      officeSaturdayClose: "2:00pm",
      officeSundayClose: "",
      gateClose: "Hours",
      gateOpenWeekend: "9:00am",
      gateCloseWeekend: "5:00pm",
      gateCloseSaturday: "Hours",
      gateCloseSunday: "Hours",
      gateOpenSaturday: "24",
      gateOpenSunday: "24",
    },
    skin: {
      accentColours: {
        primary: "#701605",
      },
      defaultUnitPicture: "https://ik.imagekit.io/bytcx9plm/3x3_f.png",
      mainColour: "#e02b0a",
      highlightColour: "#dddddd",
      themeColour: "#e02b0a",
      moveinTimeRemaining: false,
    },
    fees: {
      moveOutNotice: 7,
      lateDays: 15,
      lateFee: 20,
      adminFee: 49,
      nsfFee: 15,
      cleaningFee: 40,
      securityDeposit: 0,
    },
    DivisionID: "11",
    LanguageID: "1",
    OwnerID: "11",
    pdfFonts: {
      lease: "Arial",
      receipt: "Arial",
      insuranceDocs: "Arial",
    },
    scaConfiguration: {},
    Ret_Code: "-99",
    Ret_Msg: "General Exception from LogOn",
    collections: {
      unitTypeGroup: {
        name: "unitTypeGroup",
        job: "CDQS/L003/unitTypeGroup",
        status: "finished",
        timestamp: 1715992228912,
      },
      discountPlan: {
        name: "discountPlan",
        job: "CDQS/L003/discountPlan",
        status: "finished",
        timestamp: 1715992228913,
      },
      form: {
        name: "form",
        job: "CDQS/L003/form",
        status: "finished",
        timestamp: 1715992228914,
      },
      chargeDescription: {
        name: "chargeDescription",
        job: "CDQS/L003/chargeDescription",
        status: "finished",
        timestamp: 1715992228912,
      },
      inventory: {
        name: "inventory",
        job: "CDQS/L003/inventory",
        status: "finished",
        timestamp: 1715992228913,
      },
      paymentTypes: {
        name: "paymentTypes",
        job: "CDQS/L003/paymentTypes",
        status: "finished",
        timestamp: 1715992228914,
      },
      unitsFull: {
        name: "unitsFull",
        job: "CDQS/L003/unitsFull",
        status: "finished",
        timestamp: 1715992228912,
      },
      marketingSource: {
        name: "marketingSource",
        job: "CDQS/L003/marketingSource",
        status: "finished",
        timestamp: 1715992228913,
      },
      site: {
        name: "site",
        job: "CDQS/L003/site",
        status: "finished",
        timestamp: 1715992228912,
      },
      insuranceCoverage: {
        name: "insuranceCoverage",
        job: "CDQS/L003/insuranceCoverage",
        status: "finished",
        timestamp: 1715992228913,
      },
      paymentSettings: {
        name: "paymentSettings",
        job: "CDQS/L003/paymentSettings",
        status: "finished",
        timestamp: 1715992228914,
      },
    },
    friendlyName: null,
    originalName: "KeepSafe Storage Balcatta",
    personas: [],
    sCorpCode: "CDQS",
  },
  {
    SiteID: 33392,
    sLocationCode: "L004",
    sGlobalSiteNum: "33392",
    iMobileType: "0",
    iRegionalOptions: 1,
    iOnLineChargeType: "0",
    iGMTTimeOffset: 8,
    sLocationDesc: null,
    sSiteIDCode: null,
    sSiteRegionCode: null,
    sContactName: "Yassy Graves",
    sEmailAddress: "welshpool@keepsafestorage.com.au",
    sSiteName: "KeepSafe Storage Welshpool",
    sSiteAddr1: "46 Railway Parade",
    sSiteAddr2: null,
    sSiteCity: "Welshpool",
    sSiteRegion: "WA",
    sSitePostalCode: "6106",
    sSiteCountry: "AUSTRALIA",
    sSitePhone: "08 9200 4242",
    sSiteFAX: ".",
    sWebSiteURL: "www.keepsafestorage.com.au",
    iFeatMaxUnits: "750",
    bFeatGate: "true",
    bFeatKiosk: "true",
    bFeatRevMgmt: "true",
    bFeatCreditCards: "true",
    bFeatCorpOffice: "true",
    bFeatAccounting: "true",
    bFeatRecordStorage: "false",
    bFeatACH: "true",
    bFeatMobileStorage: "false",
    bFeatPromoAdvanced: "false",
    dACHStatus: "2018-03-01T09:01:30.477-05:00",
    bLiteVersion: "false",
    bTrial: "false",
    bSubscription: "false",
    bSiteDisabled: "false",
    dOvernightProcess: "2024-05-19T12:05:28.633-04:00",
    sLegalName: "BDST OPCO PTY LTD",
    bZipCodeData_Use: "false",
    dcLongitude: "115.9269700000",
    dcLatitude: "-31.9974320000",
    bClosedWeekdays: "false",
    bClosedSaturday: "false",
    bClosedSunday: "true",
    dWeekdayStrt: "2011-01-06T08:30:00-05:00",
    dWeekdayEnd: "2011-01-06T17:30:59-05:00",
    dSaturdayStrt: "2011-01-06T08:30:00-05:00",
    dSaturdayEnd: "2011-01-06T17:30:59-05:00",
    dSundayStrt: "2011-01-06T00:00:00-05:00",
    dSundayEnd: "2011-01-06T23:59:59-05:00",
    iIdentifier: "0",
    sIdentifier: null,
    bUseInclusiveTaxation: true,
    iBusinessType: "0",
    iSiteDataType: "0",
    sTaxNumber: "44 648 410 655",
    iFacilityUsage: "0",
    iFacilityOwnership: "0",
    iFacilityMgmt: "0",
    iFacilityLocType: "0",
    iMobileBungoRules: "0",
    iOnLinePmtsAllowed: "1",
    iEdition: "1",
    iTerminalServices: "0",
    iDST: "0",
    dCreated: "2018-03-01T09:01:29.87-05:00",
    bPermanent: "false",
    bArchived: "false",
    dUpdated: "2024-05-19T16:05:28.633Z",
    uTS: "AAAAABA5W4Q=",
    iVerboseLogging: "0",
    iSiteLinkStoreTier: "1",
    sSLBillingRef: "DQS004",
    iSubscriptionType: "0",
    tWeekdayStrt: "08:30:00",
    tWeekdayEnd: "17:30:59",
    tSaturdayStrt: "08:30:00",
    tSaturdayEnd: "17:30:59",
    tSundayStrt: "00:00:00",
    tSundayEnd: "23:59:59",
    rapidstorEnabled: true,
    dGateUpdated: "2024-05-01T08:19:15.76-04:00",
    bForcePushRates: "0",
    iWebRatesType: "0",
    ownerId: "11",
    languageId: "1",
    divisionId: "11",
    token:
      "260f47d26ac6818d2bdf907b5f6a9e73bc1ef4a108ccb3f217da203a77b819d501ba9a7a1e69d06c6913eeab4217827f",
    hours: {
      officeMondayOpen: "9:00am",
      officeTuesdayOpen: "9:00am",
      officeWednesdayOpen: "9:00am",
      officeThursdayOpen: "9:00am",
      officeFridayOpen: "9:00am",
      officeSaturdayOpen: "9:00am",
      officeSundayOpen: "Closed",
      gateOpen: "24",
      officeMondayClose: "5:00pm",
      officeTuesdayClose: "5:00pm",
      officeWednesdayClose: "5:00pm",
      officeThursdayClose: "5:00pm",
      officeFridayClose: "5:00pm",
      officeSaturdayClose: "2:00pm",
      officeSundayClose: "",
      gateClose: "Hours",
      gateOpenWeekend: "9:00am",
      gateCloseWeekend: "5:00pm",
      gateCloseSaturday: "Hours",
      gateCloseSunday: "Hours",
      gateOpenSaturday: "24",
      gateOpenSunday: "24",
    },
    skin: {
      accentColours: {
        primary: "#701605",
      },
      defaultUnitPicture: "https://ik.imagekit.io/bytcx9plm/3x3_f.png",
      mainColour: "#e02b0a",
      highlightColour: "#dddddd",
      themeColour: "#e02b0a",
      moveinTimeRemaining: false,
    },
    administrative: {
      boxshopEnabled: true,
      testMode: false,
      rslite: false,
      rsliteKey: "N/A",
      refreshEnabled: false,
      availableForUse: false,
      insuranceEnabled: false,
      merchEnabled: false,
      carouselListing: false,
      useMtasForAuth: false,
    },
    rapidstor: {
      pushRate: true,
      marketingSurvey: {
        use: true,
        questions: {
          whereHearAboutUs: {
            display: true,
            required: true,
          },
          distanceFromFacility: {
            display: true,
            required: true,
          },
          whyStoring: {
            display: true,
            required: true,
          },
          customerType: {
            display: true,
            required: true,
          },
          whatStoring: {
            display: true,
            required: true,
          },
          whyStoringWithUs: {
            display: true,
            required: true,
          },
        },
      },
      country: "AU",
      unitListing: {
        sortOrder: {
          primary: "size",
          secondary: "price",
          tertiary: "availability",
        },
        useMultilevel: true,
      },
      siteLogo:
        "https://ik.imagekit.io/bytcx9plm/CDQS-L004-logo-cjilmqaf401emhfd65jog2nce.png",
      allowOriginUrl: ["https://keepsafestorage.com.au"],
      allowedCreditCardTypes: {
        visa: true,
        mastercard: true,
        amex: false,
      },
      facilitySelfService: {
        enquiries: {
          background:
            "https://ik.imagekit.io/bytcx9plm/facility-self-service-default-enquiries.png",
        },
        takePayment: {
          background:
            "https://ik.imagekit.io/bytcx9plm/facility-self-service-default-take-payment.png",
        },
        moveOut: {
          background:
            "https://ik.imagekit.io/bytcx9plm/facility-self-service-default-moveout.png",
        },
        boxshop: {
          background:
            "https://ik.imagekit.io/bytcx9plm/facility-self-service-default-boxshop.png",
        },
      },
      tieredPricing: {
        showTiersWithNoAvailableUnits: true,
        noAvailableUnitsText: "Call for Availability",
        cherryPickBasis: "lowestRate",
        hidePrices: false,
        hideQuickSearch: false,
        showPricesShowNeeded: true,
        showVehicleQuickSearch: false,
        showAvailableUnitsCount: false,
      },
      language: {
        selectionOption: "auto-detect",
      },
      useBoxShopCoupons: false,
      useDealCoupons: false,
      siteLinkLeaseFields: [],
      wizards: {
        moveinSingle: {
          hideAlternativeContact: false,
          hideBoxshop: true,
          hideInsurance: false,
          insuranceRequired: false,
          hideDriversLicence: false,
          hideDriversLicenceState: true,
          hideDateOfBirth: false,
          hideState: false,
          hidePostalCode: false,
          allowSelfInsurance: false,
          insuranceManualEntry: false,
          requireAlternativeContactPhoneNumberField: true,
          hideInsurancePicker: false,
          allowIdUpload: true,
          allowProofOfAddressUpload: false,
          allowProofOfInsuranceUpload: false,
          insuranceAcceptancePopoverText: "",
          insuranceAcceptanceText:
            "By ticking this box you accept and agree; that the insurance coverage option selected will cover the true replacement value of your goods declared, agree to the T&C’s below and understand the inclusions/exclusions of the policy.",
          insuranceContent: "",
          insuranceContentPopoverText: "",
          insuranceManualEntryRequired: false,
          insuranceRefusedPopoverText: "",
          insuranceRefusedText:
            "By ticking this box, you are choosing not to be covered by insurance and acknowledge that we will not be held responsible for any damaged or lost goods during your rental period.",
        },
        moveinStandard: {
          requireAlternativeContactPhoneNumberField: true,
        },
        reservationWithFeeStandard: {},
      },
      features: {
        "movein-wizard": "single-page",
        "unit-listing": "modern",
        boxshop: "standard",
        "reservation-with-fee-wizard": "standard",
        "tiered-unit-listing": "standard",
        "facility-self-service": "standard",
        "facility-staff-self-service": "standard",
        "tenant-accounts": "standard",
        "carousel-unit-listing": "standard",
      },
      paymentGateways: {
        use: false,
        gatewayToUse: "",
        paypal: {
          currency: "",
          clientId: "",
          clientSecret: "",
          useTestEnv: false,
          force3dsCheck: false,
        },
        paytabs: {
          merchantEmail: "",
          secretKey: "",
          merchantSiteUrl: "",
          countryCode: "",
          messageLanguage: "",
          merchantId: "",
        },
        paygate: {
          countryCode: "",
          currency: "",
          encryptionKey: "",
          locale: "",
          payMethod: "",
          paygateId: "",
        },
        paynamics: {
          countryCode: "PH",
          currency: "",
          merchantId: "",
          merchantKey: "",
          merchantTermsUrl: "",
          paymentMethods: ["cc", "bn", "gc", "pp", "dp"],
          secure3d: "try3d",
        },
        bypassSitelinkProcessing: false,
        r6Pay: {
          currency: "",
          useTestEnv: false,
          accessToken: "",
        },
      },
      smallMediumSize: 3,
      mediumLargeSize: 14,
      moveinHideAcp: false,
      hideBoxshop: true,
      currencySymbol: "$",
      sizeSymbol: "m",
      billingDefault: "MonthlyAnniversary",
      shippingEnabled: false,
      shippingInventoryItem: null,
      allowReservation: false,
      allowMoveIn: true,
      minAvailableUnits: 0,
      noAvailableUnitsText: "Call for Availability",
      hideInsurance: false,
      insuranceRequired: false,
      legacyPickupLocationsEnabled: false,
      reservationNumberOfDaysInAdvanceLimit: 7,
      moveinNumberOfDaysInAdvanceLimit: 14,
      reservationNumberOfDaysInAdvanceChargeFee: 0,
      notificationsFromAddress: "welshpool@keepsafestorage.com.au",
      useESign: true,
      hideUnitsMinAvailable: false,
      hideQuickSearch: false,
      hideLicenseState: true,
      hideDateOfBirth: true,
      autoOptInSms: false,
      freeShippingDealEnabled: false,
      freeShippingDealAmount: 150,
      completeMoveinUrl: "",
      useAutoBilling: true,
      autoBillCheckedByDefault: false,
      doNotSendInvoiceSiteLinkWhenAutoBill: false,
      hideLicense: false,
      hideState: false,
      hidePostalCode: false,
      groundFloor: 0,
      assistanceMoving: false,
      assistanceMovingEmailAddress: "",
      quickReserveButtonText: "Quick Reserve",
      reservationExpireReservationDays: "7",
      notificationsAdditionalCcAddresses: [],
      showVehicleQuickSearch: false,
      areaSizeSymbol: "m²",
      attachLeaseToMoveInConfirmationEmail: false,
      attachReceiptToMoveInConfirmationEmail: true,
      autoOptInSMS: false,
      bookOnlineDiscount: 0,
      completeMoveinURL: "",
      enquiryAPI: {
        numOptions: 3,
      },
      forceTaxInclusive: false,
      hidePrices: false,
      insuranceCustomFormat: "",
      moveinHideACP: false,
      notificationsAdditionalCCAddresses: [],
      payLaterButtonText: "Pay Later",
      payNowButtonText: "Pay Now",
      showAutobillTerms: false,
      showPricesButtonText: "Show Prices",
      showPricesShowNeeded: true,
      showWeeklyRates: false,
      sitelinkCostRetrieveChargeNameSubstiutions: [],
      useWebRates: false,
      checkForExistingTenant: false,
      dateFormat: "dd-MM-yyyy",
      eSignReturnUrl: "https://keepsafestorage.com.au/booking-confirmation/",
      locationPageUrl: "",
      moveinEmailSubject: "",
      moveinRedirectUrl:
        "https://keepsafestorage.com.au/book-a-unit/locations/welshpool/book-confirmed",
      notificationsAdditionalBCCAddresses: [],
      recaptcha: {
        enabled: true,
        secretKey: "6Lf5GTwoAAAAAOvne7oKNDKEOmGBpxPkkjeS927u",
        siteKey: "6Lf5GTwoAAAAACOg3xVeVHJlt9MiGuzR7MI48VgM",
        tolerance: 0.5,
      },
      reservationEmailSubject: "",
      reservationPopupText: "",
      scheduleFollowUpEmails: true,
      showAreaInsteadOfDimensions: false,
      spaceCalculatorValues: {
        bedroom: 4,
        box: 0.05,
        garage: 7,
        highestValue: {
          area: 20,
          high: 30,
          low: 18,
        },
        largeItem: 1.5,
        largeRoom: 5,
        lowestValue: {
          area: 3,
          high: 5,
          low: 1,
        },
        room: 4,
        smallItem: 0.5,
        smallRoom: 3,
      },
      useDescriptorTitle: false,
      webhooks: {
        moveIn: {
          enabled: false,
          template: "",
          url: "",
        },
        pageLoad: {
          enabled: false,
          template: "",
          url: "",
        },
        reservation: {
          enabled: false,
          template: "",
          url: "",
        },
        reservationWithFee: {
          enabled: false,
          template: "",
          url: "",
        },
        docUpload: {
          enabled: false,
          template: "",
          url: "",
        },
        leadFollowUp: {
          enabled: false,
          template: "",
          url: "",
        },
        enquiry: {
          enabled: false,
          template: "",
          url: "",
        },
      },
      currency: "AUD",
      autoESignRedirect: true,
      boxshopPurchaseAttachmentName: "",
      boxshopPurchaseEmailSubject: "",
      notificationsReplyAddress: "",
      reservationExpireOccupancyValues: {
        bands: [
          {
            from: 0,
            to: 100,
            days: 30,
          },
        ],
        enabled: false,
      },
      tenantAccounts: {
        autoPayment: {
          enabled: true,
        },
        invoiceHistory: {
          enabled: true,
        },
        makePayment: {
          enabled: true,
        },
        paymentHistory: {
          enabled: true,
        },
        tenantInfo: {
          enabled: true,
        },
        uploadIdentification: {
          enabled: true,
        },
        uploadDocuments: {
          enabled: true,
          generalContent:
            "Please select & upload the following documents as a pdf or image.",
          proofOfAddress: {
            content:
              "Please upload a photo which has proof of your current address. Examples are bank statement, credit card statement or utility bill.",
            enabled: true,
            label: "Proof of Address",
          },
          proofOfId: {
            content:
              "Please upload a photo of one of your identity documents such as your Driver's Licence or National Identity Card in JPG format.",
            enabled: true,
            label: "Proof of Identification",
          },
          proofOfInsurance: {
            content:
              "Please upload a document which has proof of you being insured for your declared amount.",
            enabled: true,
            label: "Proof of Insurance",
          },
        },
        notification: {
          content: null,
          ctaButton: {
            text: null,
          },
          enabled: false,
        },
        enableMultiSiteLogin: {
          enabled: false,
        },
      },
      allowReservationsWhenNoAvailability: false,
      boxshopCategoryAlphaOrder: false,
      boxshopTermsConditions: "",
      datesClosed: "",
      eSignInsuranceFormName: "",
      eSignMoveInDocumentNames: [],
      eSignMoveInDocuments: [],
      includeFutureMoveOut: false,
      includeReservedUnitsInOccupied: true,
      insuranceEsignReturnUrl: "",
      pickupEnabled: true,
      resetPasswordUrl: "",
      showMoveInDateLimitMessage: false,
      useESignForInsuranceDocs: false,
      attachInsuranceDocsToMoveInConfirmationEmail: false,
      delayedInsurance: {
        enabled: false,
        timings: {
          days: null,
          hours: null,
          minutes: null,
        },
      },
      documentVerification: {
        enabled: false,
        providerToUse: null,
        providers: {
          rapidId: {
            label: "RapidID",
            token: null,
          },
        },
      },
      eSignInsuranceForm: {
        sFormName: null,
      },
      emailSchedules: {
        quoteUnlockFirstReminder: {
          days: null,
          hours: null,
          minutes: null,
        },
        quoteUnlockSecondReminder: {
          days: null,
          hours: null,
          minutes: null,
        },
        reservationNotMovedIn: {
          days: 0,
          hours: 0,
          mintues: null,
          minutes: 20,
        },
        quoteEmail: {
          1: {
            subject: "Your Storage Quote",
          },
          2: {
            days: 0,
            hours: 0,
            minutes: 0,
            subject: "Did you forget something?",
          },
          3: {
            days: 0,
            hours: 0,
            minutes: 0,
            subject: "Don't miss out!",
          },
        },
      },
      insurancePolicyNumberRange: {
        end: null,
        start: null,
      },
      insurancePolicyNumberRefreshNum: null,
      insuranceSmsFollowUpContent: "",
      kioskUnitListing: "standard",
      legacyPickupLocations: null,
      notificationsFromName: "Keepsafe Storage",
      siteOpeningDate: null,
      twilio: {
        accountSid: "",
        authToken: "",
        enabled: false,
        senderId: "",
      },
      directDebit: {
        creditAmount: 0,
        enabled: false,
      },
      requireAutobill: false,
      sendReservationEmailOnFeeFailure: false,
      allowSaveQuote: true,
      saveQuoteButtonText: "Save My Quote",
      saveQuotePopupText: "",
      ccSiteEmailInSaveQuote: false,
      creditCardForAutobill: {
        enabled: true,
      },
      showPricesCreatesLead: false,
    },
    fees: {
      moveOutNotice: 7,
      lateDays: 15,
      lateFee: 20,
      adminFee: 49,
      nsfFee: 15,
      cleaningFee: 40,
      securityDeposit: 0,
    },
    changedAt: "2024-05-19T21:21:31.867Z",
    changeToken:
      "a9707a00e62e765860074dc1c3cb128787645720a09b4d7cb75a58d3d331590873a18e861bd3e532723c356a9daa7bc9",
    deleted: false,
    DivisionID: "11",
    LanguageID: "1",
    OwnerID: "11",
    pdfFonts: {
      lease: "Arial",
      receipt: "Arial",
      insuranceDocs: "Arial",
    },
    scaConfiguration: {},
    collections: {
      unitsFull: {
        name: "unitsFull",
        job: "CDQS/L004/unitsFull",
        status: "finished",
        timestamp: 1716077494251,
      },
      unitTypeGroup: {
        name: "unitTypeGroup",
        job: "TRIGGERED: CDQS/L004/unitTypeGroup",
        status: "finished",
        timestamp: 1716135479312,
      },
      inventory: {
        name: "inventory",
        job: "CDQS/L004/inventory",
        status: "finished",
        timestamp: 1715992228916,
      },
      paymentSettings: {
        name: "paymentSettings",
        job: "CDQS/L004/paymentSettings",
        status: "finished",
        timestamp: 1715992228916,
      },
      paymentTypes: {
        name: "paymentTypes",
        job: "CDQS/L004/paymentTypes",
        status: "finished",
        timestamp: 1715992228918,
      },
      discountPlan: {
        name: "discountPlan",
        job: "CDQS/L004/discountPlan",
        status: "finished",
        timestamp: 1715992228916,
      },
      form: {
        name: "form",
        job: "CDQS/L004/form",
        status: "finished",
        timestamp: 1715992228918,
      },
      chargeDescription: {
        name: "chargeDescription",
        job: "CDQS/L004/chargeDescription",
        status: "finished",
        timestamp: 1715992228916,
      },
      insuranceCoverage: {
        name: "insuranceCoverage",
        job: "CDQS/L004/insuranceCoverage",
        status: "finished",
        timestamp: 1715992228916,
      },
      site: {
        name: "site",
        job: "CDQS/L004/site",
        status: "finished",
        timestamp: 1715992228914,
      },
      marketingSource: {
        name: "marketingSource",
        job: "CDQS/L004/marketingSource",
        status: "finished",
        timestamp: 1715992228916,
      },
    },
    friendlyName: null,
    originalName: "KeepSafe Storage Welshpool",
    personas: [],
    sCorpCode: "CDQS",
  },
  {
    SiteID: 31482,
    sLocationCode: "L005",
    __v: 0,
    sGlobalSiteNum: "31482",
    iRegionalOptions: 1,
    iGMTTimeOffset: 8,
    sContactName: "Yassy Graves",
    sEmailAddress: "info@welshpoolselfstorage.com.au",
    sSiteName: "Welshpool Self Storage",
    sSiteAddr1: "1 Babel St",
    sSiteCity: "Welshpool",
    sSiteRegion: "WA",
    sSitePostalCode: "6106",
    sSiteCountry: "AUSTRALIA",
    sSitePhone: "08 9451 3456",
    bUseInclusiveTaxation: true,
    sTaxNumber: "44 648 410 655",
    dUpdated: "2024-05-18T16:02:10.270Z",
    uTS: "AAAAABA40+k=",
    rapidstorEnabled: true,
    iMobileType: "0",
    iOnLineChargeType: "0",
    sSiteFAX: ".",
    sWebSiteURL: "www.welshpoolselfstorage.com.au",
    iFeatMaxUnits: "750",
    bFeatGate: "true",
    bFeatKiosk: "true",
    bFeatRevMgmt: "true",
    bFeatCreditCards: "true",
    bFeatCorpOffice: "true",
    bFeatAccounting: "true",
    bFeatRecordStorage: "false",
    bFeatACH: "true",
    bFeatMobileStorage: "false",
    bFeatPromoAdvanced: "false",
    dACHStatus: "2017-06-30T11:20:23.37-04:00",
    bLiteVersion: "false",
    bTrial: "false",
    bSubscription: "false",
    bSiteDisabled: "false",
    dGateUpdated: "2024-05-15T08:58:29.857-04:00",
    dOvernightProcess: "2024-05-18T12:02:10.27-04:00",
    sLegalName: "BDST OPCO PTY LTD",
    bZipCodeData_Use: "false",
    dcLongitude: "115.9308040000",
    dcLatitude: "-31.9935980000",
    bClosedWeekdays: "false",
    bClosedSaturday: "false",
    bClosedSunday: "true",
    dWeekdayStrt: "2011-01-06T08:30:00-05:00",
    dWeekdayEnd: "2011-01-06T17:30:59-05:00",
    dSaturdayStrt: "2011-01-06T08:30:00-05:00",
    dSaturdayEnd: "2011-01-06T17:30:59-05:00",
    dSundayStrt: "2011-01-06T00:00:00-05:00",
    dSundayEnd: "2011-01-06T23:59:59-05:00",
    iIdentifier: "0",
    iBusinessType: "0",
    iSiteDataType: "0",
    iFacilityUsage: "0",
    iFacilityOwnership: "0",
    iFacilityMgmt: "0",
    iFacilityLocType: "0",
    iMobileBungoRules: "0",
    iOnLinePmtsAllowed: "0",
    iEdition: "1",
    iTerminalServices: "0",
    iDST: "0",
    dCreated: "2017-06-30T11:20:22.993-04:00",
    bPermanent: "false",
    bArchived: "false",
    iVerboseLogging: "0",
    iSiteLinkStoreTier: "1",
    sSLBillingRef: "DQS005",
    iSubscriptionType: "0",
    tWeekdayStrt: "08:30:00",
    tWeekdayEnd: "17:30:59",
    tSaturdayStrt: "08:30:00",
    tSaturdayEnd: "17:30:59",
    tSundayStrt: "00:00:00",
    tSundayEnd: "23:59:59",
    sLocationDesc: null,
    sSiteIDCode: null,
    sSiteRegionCode: null,
    sSiteAddr2: null,
    sIdentifier: null,
    bForcePushRates: "0",
    iWebRatesType: "0",
    token:
      "d81e547a5f19a404e7722eb5d0814094a11779b72e59133ad704938fa70e596cd66b64670837fdfa13523b25acd90594",
    changedAt: "2024-05-19T11:50:53.600Z",
    changeToken:
      "1de30658a598ff44b346bd0631df3c9a75ef00f65f9f22f3c80fb99c01cae4a8e56afa0b55de5cc738a85cd7c0a81d39",
    deleted: false,
    administrative: {
      boxshopEnabled: true,
      testMode: false,
      rslite: false,
      rsliteKey: "N/A",
      refreshEnabled: false,
      availableForUse: false,
      insuranceEnabled: false,
      merchEnabled: false,
      carouselListing: false,
      useMtasForAuth: false,
    },
    rapidstor: {
      siteLogo:
        "https://ik.imagekit.io/bytcx9plm/CDQS-L005-logo-ck11ev6mj0001o2mon10mt2j2.png",
      pushRate: true,
      marketingSurvey: {
        use: true,
        questions: {
          whereHearAboutUs: {
            display: true,
            required: true,
          },
          distanceFromFacility: {
            display: true,
            required: true,
          },
          whyStoring: {
            display: true,
            required: true,
          },
          customerType: {
            display: true,
            required: true,
          },
          whatStoring: {
            display: true,
            required: true,
          },
          whyStoringWithUs: {
            display: true,
            required: true,
          },
        },
      },
      country: "AU",
      unitListing: {
        sortOrder: {
          primary: "size",
          secondary: "price",
          tertiary: "availability",
        },
        useMultilevel: true,
      },
      allowOriginUrl: ["https://welshpoolselfstorage.com.au"],
      allowedCreditCardTypes: {
        visa: true,
        mastercard: true,
        amex: false,
      },
      siteLinkLeaseFields: [],
      facilitySelfService: {
        enquiries: {
          background:
            "https://ik.imagekit.io/bytcx9plm/facility-self-service-default-enquiries.png",
        },
        takePayment: {
          background:
            "https://ik.imagekit.io/bytcx9plm/facility-self-service-default-take-payment.png",
        },
        moveOut: {
          background:
            "https://ik.imagekit.io/bytcx9plm/facility-self-service-default-moveout.png",
        },
        boxshop: {
          background:
            "https://ik.imagekit.io/bytcx9plm/facility-self-service-default-boxshop.png",
        },
      },
      tieredPricing: {
        showTiersWithNoAvailableUnits: true,
        noAvailableUnitsText: "Call for Availability",
        cherryPickBasis: "lowestRate",
        hidePrices: false,
        hideQuickSearch: false,
        showPricesShowNeeded: true,
        showVehicleQuickSearch: false,
        showAvailableUnitsCount: false,
      },
      language: {
        selectionOption: "auto-detect",
      },
      useBoxShopCoupons: false,
      useDealCoupons: false,
      wizards: {
        moveinSingle: {
          hideAlternativeContact: false,
          hideBoxshop: true,
          hideInsurance: false,
          insuranceRequired: false,
          hideDriversLicence: false,
          hideDriversLicenceState: true,
          hideDateOfBirth: false,
          hideState: false,
          hidePostalCode: false,
          allowSelfInsurance: false,
          insuranceManualEntry: false,
          requireAlternativeContactPhoneNumberField: true,
          hideInsurancePicker: false,
          allowIdUpload: true,
          allowProofOfAddressUpload: false,
          allowProofOfInsuranceUpload: false,
          insuranceAcceptancePopoverText: "",
          insuranceAcceptanceText:
            "By ticking this box you accept and agree; that the insurance coverage option selected will cover the true replacement value of your goods declared, agree to the T&C’s below and understand the inclusions/exclusions of the policy.",
          insuranceContent: "",
          insuranceContentPopoverText: "",
          insuranceManualEntryRequired: false,
          insuranceRefusedPopoverText: "",
          insuranceRefusedText:
            "By ticking this box, you are choosing not to be covered by insurance and acknowledge that we will not be held responsible for any damaged or lost goods during your rental period.",
        },
        moveinStandard: {
          requireAlternativeContactPhoneNumberField: true,
        },
        reservationWithFeeStandard: {},
      },
      features: {
        "movein-wizard": "single-page",
        "unit-listing": "modern",
        boxshop: "standard",
        "reservation-with-fee-wizard": "standard",
        "tiered-unit-listing": "standard",
        "facility-self-service": "standard",
        "facility-staff-self-service": "standard",
        "tenant-accounts": "standard",
        "carousel-unit-listing": "standard",
      },
      forceTaxInclusive: false,
      paymentGateways: {
        use: false,
        gatewayToUse: "",
        paypal: {
          currency: "",
          clientId: "",
          clientSecret: "",
          useTestEnv: false,
          force3dsCheck: false,
        },
        paytabs: {
          merchantEmail: "",
          secretKey: "",
          merchantSiteUrl: "",
          countryCode: "",
          messageLanguage: "",
          merchantId: "",
        },
        paygate: {
          countryCode: "",
          currency: "",
          encryptionKey: "",
          locale: "",
          payMethod: "",
          paygateId: "",
        },
        paynamics: {
          countryCode: "PH",
          currency: "",
          merchantId: "",
          merchantKey: "",
          merchantTermsUrl: "",
          paymentMethods: ["cc", "bn", "gc", "pp", "dp"],
          secure3d: "try3d",
        },
        bypassSitelinkProcessing: false,
        r6Pay: {
          currency: "",
          useTestEnv: false,
          accessToken: "",
        },
      },
      billingDefault: "MonthlyAnniversary",
      sizeSymbol: "m",
      minAvailableUnits: 0,
      hideUnitsMinAvailable: true,
      noAvailableUnitsText: "Call for Availability",
      quickReserveButtonText: "Quick Reserve",
      hideQuickSearch: false,
      smallMediumSize: 3,
      mediumLargeSize: 9,
      moveinHideAcp: false,
      insuranceRequired: false,
      hideBoxshop: false,
      hideInsurance: false,
      hideLicense: false,
      hideLicenseState: true,
      hideDateOfBirth: true,
      hideState: false,
      hidePostalCode: false,
      autoOptInSms: false,
      currencySymbol: "$",
      groundFloor: 0,
      shippingEnabled: false,
      legacyPickupLocationsEnabled: false,
      freeShippingDealEnabled: false,
      freeShippingDealAmount: 150,
      allowReservation: false,
      allowMoveIn: true,
      reservationNumberOfDaysInAdvanceLimit: 7,
      moveinNumberOfDaysInAdvanceLimit: 14,
      reservationNumberOfDaysInAdvanceChargeFee: 0,
      assistanceMoving: false,
      assistanceMovingEmailAddress: "",
      notificationsFromAddress: "",
      completeMoveinUrl: "",
      useESign: true,
      useAutoBilling: true,
      autoBillCheckedByDefault: false,
      doNotSendInvoiceSiteLinkWhenAutoBill: false,
      showVehicleQuickSearch: false,
      reservationExpireReservationDays: "7",
      notificationsAdditionalCcAddresses: [],
      areaSizeSymbol: "m²",
      attachLeaseToMoveInConfirmationEmail: false,
      attachReceiptToMoveInConfirmationEmail: true,
      autoOptInSMS: false,
      bookOnlineDiscount: 0,
      completeMoveinURL: "",
      enquiryAPI: {
        numOptions: 3,
      },
      hidePrices: false,
      insuranceCustomFormat: "",
      moveinHideACP: false,
      notificationsAdditionalCCAddresses: [],
      payLaterButtonText: "Pay Later",
      payNowButtonText: "Pay Now",
      showAutobillTerms: false,
      showPricesButtonText: "Show Prices",
      showPricesShowNeeded: true,
      showWeeklyRates: false,
      sitelinkCostRetrieveChargeNameSubstiutions: [],
      useWebRates: false,
      checkForExistingTenant: false,
      dateFormat: "dd-MM-yyyy",
      eSignReturnUrl: "",
      locationPageUrl: "",
      moveinEmailSubject: "",
      moveinRedirectUrl: "",
      notificationsAdditionalBCCAddresses: [],
      recaptcha: {
        enabled: false,
        secretKey: "",
        siteKey: "",
        tolerance: 0.5,
      },
      reservationEmailSubject: "",
      reservationPopupText: "",
      scheduleFollowUpEmails: true,
      showAreaInsteadOfDimensions: false,
      spaceCalculatorValues: {
        bedroom: 4,
        box: 0.05,
        garage: 7,
        highestValue: {
          area: 20,
          high: 30,
          low: 18,
        },
        largeItem: 1.5,
        largeRoom: 5,
        lowestValue: {
          area: 3,
          high: 5,
          low: 1,
        },
        room: 4,
        smallItem: 0.5,
        smallRoom: 3,
      },
      useDescriptorTitle: false,
      webhooks: {
        moveIn: {
          enabled: false,
          template: "",
          url: "",
        },
        pageLoad: {
          enabled: false,
          template: "",
          url: "",
        },
        reservation: {
          enabled: false,
          template: "",
          url: "",
        },
        reservationWithFee: {
          enabled: false,
          template: "",
          url: "",
        },
        docUpload: {
          enabled: false,
          template: "",
          url: "",
        },
        leadFollowUp: {
          enabled: false,
          template: "",
          url: "",
        },
        enquiry: {
          enabled: false,
          template: "",
          url: "",
        },
      },
      currency: "AUD",
      autoESignRedirect: true,
      boxshopPurchaseAttachmentName: "",
      boxshopPurchaseEmailSubject: "",
      notificationsReplyAddress: "",
      reservationExpireOccupancyValues: {
        bands: [
          {
            from: 0,
            to: 100,
            days: 30,
          },
        ],
        enabled: false,
      },
      tenantAccounts: {
        autoPayment: {
          enabled: true,
        },
        invoiceHistory: {
          enabled: true,
        },
        makePayment: {
          enabled: true,
        },
        paymentHistory: {
          enabled: true,
        },
        tenantInfo: {
          enabled: true,
        },
        uploadIdentification: {
          enabled: true,
        },
        uploadDocuments: {
          enabled: true,
          generalContent:
            "Please select & upload the following documents as a pdf or image.",
          proofOfAddress: {
            content:
              "Please upload a photo which has proof of your current address. Examples are bank statement, credit card statement or utility bill.",
            enabled: true,
            label: "Proof of Address",
          },
          proofOfId: {
            content:
              "Please upload a photo of one of your identity documents such as your Driver's Licence or National Identity Card in JPG format.",
            enabled: true,
            label: "Proof of Identification",
          },
          proofOfInsurance: {
            content:
              "Please upload a document which has proof of you being insured for your declared amount.",
            enabled: true,
            label: "Proof of Insurance",
          },
        },
        notification: {
          content: null,
          ctaButton: {
            text: null,
          },
          enabled: false,
        },
        enableMultiSiteLogin: {
          enabled: false,
        },
      },
      allowReservationsWhenNoAvailability: false,
      boxshopCategoryAlphaOrder: false,
      boxshopTermsConditions: "",
      datesClosed: "",
      eSignInsuranceFormName: "",
      eSignMoveInDocumentNames: [],
      eSignMoveInDocuments: [],
      includeFutureMoveOut: false,
      includeReservedUnitsInOccupied: true,
      insuranceEsignReturnUrl: "",
      pickupEnabled: true,
      resetPasswordUrl: "",
      showMoveInDateLimitMessage: false,
      useESignForInsuranceDocs: false,
      attachInsuranceDocsToMoveInConfirmationEmail: false,
      delayedInsurance: {
        enabled: false,
        timings: {
          days: null,
          hours: null,
          minutes: null,
        },
      },
      documentVerification: {
        enabled: false,
        providerToUse: null,
        providers: {
          rapidId: {
            label: "RapidID",
            token: null,
          },
        },
      },
      eSignInsuranceForm: {
        sFormName: null,
      },
      emailSchedules: {
        quoteUnlockFirstReminder: {
          days: null,
          hours: null,
          minutes: null,
        },
        quoteUnlockSecondReminder: {
          days: null,
          hours: null,
          minutes: null,
        },
        reservationNotMovedIn: {
          days: 0,
          hours: 0,
          mintues: null,
          minutes: 20,
        },
        quoteEmail: {
          1: {
            subject: "Your Storage Quote",
          },
          2: {
            days: 0,
            hours: 0,
            minutes: 0,
            subject: "Did you forget something?",
          },
          3: {
            days: 0,
            hours: 0,
            minutes: 0,
            subject: "Don't miss out!",
          },
        },
      },
      insurancePolicyNumberRange: {
        end: null,
        start: null,
      },
      insurancePolicyNumberRefreshNum: null,
      insuranceSmsFollowUpContent: "",
      kioskUnitListing: "standard",
      legacyPickupLocations: null,
      notificationsFromName: "",
      shippingInventoryItem: null,
      siteOpeningDate: null,
      twilio: {
        accountSid: "",
        authToken: "",
        enabled: false,
        senderId: "",
      },
      directDebit: {
        creditAmount: 0,
        enabled: false,
      },
      requireAutobill: false,
      sendReservationEmailOnFeeFailure: false,
      allowSaveQuote: true,
      saveQuoteButtonText: "Save My Quote",
      saveQuotePopupText: "",
      ccSiteEmailInSaveQuote: false,
      creditCardForAutobill: {
        enabled: true,
      },
      showPricesCreatesLead: false,
    },
    ownerId: "11",
    languageId: "1",
    divisionId: "11",
    hours: {
      officeMondayOpen: "9:00am",
      officeTuesdayOpen: "9:00am",
      officeWednesdayOpen: "9:00am",
      officeThursdayOpen: "9:00am",
      officeFridayOpen: "9:00am",
      officeSaturdayOpen: "9:00am",
      officeSundayOpen: "CLOSED",
      officeMondayClose: "5:00pm",
      officeTuesdayClose: "5:00pm",
      officeWednesdayClose: "5:00pm",
      officeThursdayClose: "5:00pm",
      officeFridayClose: "5:00pm",
      officeSaturdayClose: "2:00pm",
      officeSundayClose: "",
      gateOpen: "24",
      gateClose: "Hours",
      gateOpenWeekend: "9:00am",
      gateCloseWeekend: "5:00pm",
      gateCloseSaturday: "Hours",
      gateCloseSunday: "Hours",
      gateOpenSaturday: "24",
      gateOpenSunday: "24",
    },
    skin: {
      accentColours: {
        primary: "#87003F",
      },
      defaultUnitPicture: "https://ik.imagekit.io/bytcx9plm/3x3_f.png",
      mainColour: "#0055A5",
      highlightColour: "",
      moveinTimeRemaining: false,
    },
    fees: {
      moveOutNotice: 7,
      lateDays: 10,
      lateFee: 20,
      adminFee: 29,
      nsfFee: 15,
      cleaningFee: "0",
      securityDeposit: 0,
    },
    DivisionID: "11",
    LanguageID: "1",
    OwnerID: "11",
    pdfFonts: {
      lease: "Arial",
      receipt: "Arial",
      insuranceDocs: "Arial",
    },
    scaConfiguration: {},
    collections: {
      unitTypeGroup: {
        name: "unitTypeGroup",
        job: "TRIGGERED: CDQS/L005/unitTypeGroup",
        status: "finished",
        timestamp: 1716167962949,
      },
      form: {
        name: "form",
        job: "CDQS/L005/form",
        status: "finished",
        timestamp: 1715992228920,
      },
      inventory: {
        name: "inventory",
        job: "CDQS/L005/inventory",
        status: "finished",
        timestamp: 1715992228919,
      },
      paymentTypes: {
        name: "paymentTypes",
        job: "CDQS/L005/paymentTypes",
        status: "finished",
        timestamp: 1715992228920,
      },
      marketingSource: {
        name: "marketingSource",
        job: "CDQS/L005/marketingSource",
        status: "finished",
        timestamp: 1715992228920,
      },
      site: {
        name: "site",
        job: "CDQS/L005/site",
        status: "finished",
        timestamp: 1715992228919,
      },
      insuranceCoverage: {
        name: "insuranceCoverage",
        job: "CDQS/L005/insuranceCoverage",
        status: "finished",
        timestamp: 1715992228919,
      },
      unitsFull: {
        name: "unitsFull",
        job: "CDQS/L005/unitsFull",
        status: "finished",
        timestamp: 1715992228918,
      },
      chargeDescription: {
        name: "chargeDescription",
        job: "CDQS/L005/chargeDescription",
        status: "finished",
        timestamp: 1715992228919,
      },
      paymentSettings: {
        name: "paymentSettings",
        job: "CDQS/L005/paymentSettings",
        status: "finished",
        timestamp: 1716077494255,
      },
      discountPlan: {
        name: "discountPlan",
        job: "CDQS/L005/discountPlan",
        status: "finished",
        timestamp: 1715992228920,
      },
    },
    friendlyName: null,
    originalName: "Welshpool Self Storage",
    personas: [],
    sCorpCode: "CDQS",
  },
  {
    SiteID: "37872",
    sLocationCode: "L006",
    sGlobalSiteNum: "37872",
    iMobileType: "0",
    iRegionalOptions: "1",
    iOnLineChargeType: "0",
    iGMTTimeOffset: "8",
    sLocationDesc: null,
    sSiteIDCode: null,
    sSiteRegionCode: "WA",
    sContactName: null,
    sEmailAddress: "mandurah@keepsafestorage.com.au",
    sSiteName: "KeepSafe Storage Mandurah",
    sSiteAddr1: "34 Thornborough Road",
    sSiteAddr2: null,
    sSiteCity: "Greenfields",
    sSiteRegion: "WA",
    sSitePostalCode: "6210",
    sSiteCountry: "AUS",
    sSitePhone: "08 9583 3999",
    sSiteFAX: ".",
    sWebSiteURL: "http://www.keepsafestorage.com.au",
    iFeatMaxUnits: "750",
    bFeatGate: "true",
    bFeatKiosk: "true",
    bFeatRevMgmt: "true",
    bFeatCreditCards: "true",
    bFeatCorpOffice: "true",
    bFeatAccounting: "true",
    bFeatRecordStorage: "false",
    bFeatACH: "true",
    bFeatMobileStorage: "false",
    bFeatPromoAdvanced: "false",
    dACHStatus: "2015-05-26T10:29:14.353-04:00",
    bLiteVersion: "false",
    bTrial: "false",
    bSubscription: "false",
    bSiteDisabled: "false",
    dOvernightProcess: "2020-11-25T11:03:10.887-05:00",
    sLegalName: "Mandurah Self Storage Pty Ltd",
    bZipCodeData_Use: "false",
    dcLongitude: "115.7527580000",
    dcLatitude: "-32.5165630000",
    bClosedWeekdays: "false",
    bClosedSaturday: "false",
    bClosedSunday: "true",
    dWeekdayStrt: "2008-07-02T08:00:00-04:00",
    dWeekdayEnd: "2008-07-02T17:00:00-04:00",
    dSaturdayStrt: "2008-07-02T09:00:00-04:00",
    dSaturdayEnd: "2008-07-02T14:00:00-04:00",
    dSundayStrt: "2008-07-02T00:00:00-04:00",
    dSundayEnd: "2008-07-02T23:59:00-04:00",
    iIdentifier: "0",
    sIdentifier: null,
    bUseInclusiveTaxation: "true",
    iBusinessType: "-33",
    iSiteDataType: "0",
    sTaxNumber: "97 601 378 205",
    iFacilityUsage: "0",
    iFacilityOwnership: "0",
    iFacilityMgmt: "0",
    iFacilityLocType: "0",
    iMobileBungoRules: "0",
    iOnLinePmtsAllowed: "1",
    iEdition: "1",
    iTerminalServices: "0",
    iDST: "0",
    dCreated: "2019-07-31T13:46:30.507-04:00",
    bPermanent: "false",
    bArchived: "false",
    dUpdated: "2020-11-25T11:03:10.887-05:00",
    uTS: "AAAAAAuyLnw=",
    iVerboseLogging: "0",
    iSiteLinkStoreTier: "1",
    sSLBillingRef: "DQS006",
    iSubscriptionType: "0",
    tWeekdayStrt: "08:00:00",
    tWeekdayEnd: "17:00:00",
    tSaturdayStrt: "09:00:00",
    tSaturdayEnd: "14:00:00",
    tSundayStrt: "00:00:00",
    tSundayEnd: "23:59:00",
    rapidstorEnabled: false,
    dGateUpdated: "2020-11-23T16:15:54.55-05:00",
    bForcePushRates: "0",
    iWebRatesType: "0",
    ownerId: "11",
    languageId: "1",
    divisionId: "11",
    hours: {
      officeMondayOpen: "8:00am",
      officeTuesdayOpen: "8:00am",
      officeWednesdayOpen: "8:00am",
      officeThursdayOpen: "8:00am",
      officeFridayOpen: "8:00am",
      officeSaturdayOpen: "9:00am",
      officeSundayOpen: "Closed",
      officeMondayClose: "5:00pm",
      officeTuesdayClose: "5:00pm",
      officeWednesdayClose: "5:00pm",
      officeThursdayClose: "5:00pm",
      officeFridayClose: "5:00pm",
      officeSaturdayClose: "2:00pm",
      officeSundayClose: "Closed",
      gateOpen: "5:00am",
      gateClose: "9:00pm",
      gateOpenWeekend: "5:00am",
      gateCloseWeekend: "9:00pm",
      gateCloseSaturday: "9:00pm",
      gateCloseSunday: "9:00pm",
      gateOpenSaturday: "5:00am",
      gateOpenSunday: "5:00am",
    },
    skin: {
      accentColours: {
        primary: "#701605",
      },
      defaultUnitPicture: "https://ik.imagekit.io/bytcx9plm/3x3_f.png",
      mainColour: "#e02b0a",
      highlightColour: "#dddddd",
      moveinTimeRemaining: false,
    },
    administrative: {
      boxshopEnabled: true,
      testMode: false,
      rslite: false,
      rsliteKey: "N/A",
      refreshEnabled: false,
      availableForUse: false,
      insuranceEnabled: false,
      merchEnabled: false,
      carouselListing: false,
      useMtasForAuth: false,
    },
    rapidstor: {
      pushRate: true,
      siteLinkLeaseFields: [],
      marketingSurvey: {
        use: true,
        questions: {
          whereHearAboutUs: {
            display: true,
            required: true,
          },
          distanceFromFacility: {
            display: true,
            required: true,
          },
          whyStoring: {
            display: true,
            required: true,
          },
          customerType: {
            display: true,
            required: true,
          },
          whatStoring: {
            display: true,
            required: true,
          },
          whyStoringWithUs: {
            display: true,
            required: true,
          },
        },
      },
      country: "AU",
      unitListing: {
        sortOrder: {
          primary: "size",
          secondary: "price",
          tertiary: "availability",
        },
        useMultilevel: true,
      },
      siteLogo:
        "https://ik.imagekit.io/bytcx9plm/CDQS-L006-logo-cjytd5eqm000dx4mo8paju0hl.png",
      allowOriginUrl: ["https://keepsafestorage.com.au"],
      allowedCreditCardTypes: {
        visa: true,
        mastercard: true,
        amex: false,
      },
      facilitySelfService: {
        enquiries: {
          background:
            "https://ik.imagekit.io/bytcx9plm/facility-self-service-default-enquiries.png",
        },
        takePayment: {
          background:
            "https://ik.imagekit.io/bytcx9plm/facility-self-service-default-take-payment.png",
        },
        moveOut: {
          background:
            "https://ik.imagekit.io/bytcx9plm/facility-self-service-default-moveout.png",
        },
        boxshop: {
          background:
            "https://ik.imagekit.io/bytcx9plm/facility-self-service-default-boxshop.png",
        },
      },
      tieredPricing: {
        showTiersWithNoAvailableUnits: true,
        noAvailableUnitsText: "Call for Availability",
        cherryPickBasis: "lowestRate",
        hidePrices: false,
        hideQuickSearch: false,
        showPricesShowNeeded: true,
        showVehicleQuickSearch: false,
        showAvailableUnitsCount: false,
      },
      language: {
        selectionOption: "auto-detect",
      },
      useBoxShopCoupons: false,
      useDealCoupons: false,
      wizards: {
        moveinStandard: {
          requireAlternativeContactPhoneNumberField: true,
        },
        moveinSingle: {
          hideAlternativeContact: false,
          hideBoxshop: false,
          hideInsurance: false,
          insuranceRequired: false,
          hideDriversLicence: false,
          hideDriversLicenceState: true,
          hideDateOfBirth: true,
          hideState: false,
          hidePostalCode: false,
          allowSelfInsurance: false,
          insuranceManualEntry: false,
          requireAlternativeContactPhoneNumberField: true,
          hideInsurancePicker: false,
          allowIdUpload: false,
          allowProofOfAddressUpload: false,
          allowProofOfInsuranceUpload: false,
          insuranceAcceptancePopoverText: "",
          insuranceAcceptanceText:
            "By ticking this box you accept and agree; that the insurance coverage option selected will cover the true replacement value of your goods declared, agree to the T&C’s below and understand the inclusions/exclusions of the policy.",
          insuranceContent: "",
          insuranceContentPopoverText: "",
          insuranceManualEntryRequired: false,
          insuranceRefusedPopoverText: "",
          insuranceRefusedText:
            "By ticking this box, you are choosing not to be covered by insurance and acknowledge that we will not be held responsible for any damaged or lost goods during your rental period.",
        },
        reservationWithFeeStandard: {},
      },
      features: {
        "movein-wizard": "single-page",
        "unit-listing": "standard",
        boxshop: "standard",
        "reservation-with-fee-wizard": "standard",
        "tiered-unit-listing": "standard",
        "facility-self-service": "standard",
        "facility-staff-self-service": "standard",
        "tenant-accounts": "standard",
        "carousel-unit-listing": "standard",
      },
      paymentGateways: {
        use: false,
        gatewayToUse: "",
        paypal: {
          currency: "",
          clientId: "",
          clientSecret: "",
          useTestEnv: false,
          force3dsCheck: false,
        },
        paytabs: {
          merchantEmail: "",
          secretKey: "",
          merchantSiteUrl: "",
          countryCode: "",
          messageLanguage: "",
          merchantId: "",
        },
        paygate: {
          countryCode: "",
          currency: "",
          encryptionKey: "",
          locale: "",
          payMethod: "",
          paygateId: "",
        },
        paynamics: {
          countryCode: "PH",
          currency: "",
          merchantId: "",
          merchantKey: "",
          merchantTermsUrl: "",
          paymentMethods: ["cc", "bn", "gc", "pp", "dp"],
          secure3d: "try3d",
        },
        bypassSitelinkProcessing: false,
        r6Pay: {
          currency: "",
          useTestEnv: false,
          accessToken: "",
        },
      },
      minAvailableUnits: 0,
      hideUnitsMinAvailable: true,
      noAvailableUnitsText: "Call for Availability",
      quickReserveButtonText: "Quick Reserve",
      hideQuickSearch: false,
      showVehicleQuickSearch: false,
      smallMediumSize: 8,
      mediumLargeSize: 14,
      moveinHideAcp: false,
      insuranceRequired: false,
      hideBoxshop: false,
      hideInsurance: false,
      hideLicense: false,
      hideLicenseState: true,
      hideDateOfBirth: true,
      hideState: false,
      hidePostalCode: false,
      autoOptInSms: false,
      currencySymbol: "$",
      sizeSymbol: "m",
      groundFloor: 0,
      billingDefault: "MonthlyAnniversary",
      shippingEnabled: false,
      legacyPickupLocationsEnabled: false,
      legacyPickupLocations: null,
      shippingInventoryItem: null,
      freeShippingDealEnabled: false,
      freeShippingDealAmount: 150,
      allowReservation: true,
      allowMoveIn: false,
      reservationNumberOfDaysInAdvanceLimit: 30,
      moveinNumberOfDaysInAdvanceLimit: 7,
      reservationNumberOfDaysInAdvanceChargeFee: 365,
      reservationExpireReservationDays: 30,
      assistanceMoving: false,
      assistanceMovingEmailAddress: "",
      notificationsFromAddress: "",
      notificationsAdditionalCcAddresses: [],
      completeMoveinUrl: "",
      useESign: false,
      useAutoBilling: true,
      autoBillCheckedByDefault: false,
      doNotSendInvoiceSiteLinkWhenAutoBill: false,
      areaSizeSymbol: "m²",
      attachLeaseToMoveInConfirmationEmail: true,
      attachReceiptToMoveInConfirmationEmail: true,
      autoOptInSMS: false,
      bookOnlineDiscount: 0,
      completeMoveinURL: "",
      enquiryAPI: {
        numOptions: 3,
      },
      forceTaxInclusive: false,
      hidePrices: false,
      insuranceCustomFormat: "",
      moveinHideACP: false,
      notificationsAdditionalCCAddresses: [],
      payLaterButtonText: "Pay Later",
      payNowButtonText: "Pay Now",
      showAutobillTerms: false,
      showPricesButtonText: "Show Prices",
      showPricesShowNeeded: true,
      showWeeklyRates: false,
      sitelinkCostRetrieveChargeNameSubstiutions: [],
      useWebRates: false,
      checkForExistingTenant: false,
      currency: "AUD",
      dateFormat: "yyyy-MM-dd",
      eSignReturnUrl: "",
      locationPageUrl: "",
      moveinEmailSubject: "",
      moveinRedirectUrl: "",
      notificationsAdditionalBCCAddresses: [],
      recaptcha: {
        enabled: false,
        secretKey: "",
        siteKey: "",
        tolerance: 0.5,
      },
      reservationEmailSubject: "",
      reservationPopupText: "",
      scheduleFollowUpEmails: false,
      showAreaInsteadOfDimensions: false,
      spaceCalculatorValues: {
        bedroom: 4,
        box: 0.05,
        garage: 7,
        highestValue: {
          area: 20,
          high: 30,
          low: 18,
        },
        largeItem: 1.5,
        largeRoom: 5,
        lowestValue: {
          area: 3,
          high: 5,
          low: 1,
        },
        room: 4,
        smallItem: 0.5,
        smallRoom: 3,
      },
      useDescriptorTitle: false,
      webhooks: {
        moveIn: {
          enabled: false,
          template: "",
          url: "",
        },
        pageLoad: {
          enabled: false,
          template: "",
          url: "",
        },
        reservation: {
          enabled: false,
          template: "",
          url: "",
        },
        reservationWithFee: {
          enabled: false,
          template: "",
          url: "",
        },
        docUpload: {
          enabled: false,
          template: "",
          url: "",
        },
        enquiry: {
          enabled: false,
          template: "",
          url: "",
        },
        leadFollowUp: {
          enabled: false,
          template: "",
          url: "",
        },
      },
      allowSaveQuote: false,
      allowReservationsWhenNoAvailability: false,
      attachInsuranceDocsToMoveInConfirmationEmail: false,
      autoESignRedirect: false,
      boxshopCategoryAlphaOrder: false,
      boxshopPurchaseAttachmentName: "",
      boxshopPurchaseEmailSubject: "",
      boxshopTermsConditions: "",
      datesClosed: "",
      delayedInsurance: {
        enabled: false,
        timings: {
          days: null,
          hours: null,
          minutes: null,
        },
      },
      directDebit: {
        enabled: false,
        creditAmount: 0,
      },
      documentVerification: {
        enabled: false,
        providerToUse: null,
        providers: {
          rapidId: {
            label: "RapidID",
            token: null,
          },
        },
      },
      emailSchedules: {
        quoteEmail: {
          1: {
            subject: null,
          },
          2: {
            subject: null,
            days: null,
            hours: null,
            minutes: null,
          },
          3: {
            subject: null,
            days: null,
            hours: null,
            minutes: null,
          },
        },
        quoteUnlockFirstReminder: {
          days: null,
          hours: null,
          minutes: null,
        },
        quoteUnlockSecondReminder: {
          days: null,
          hours: null,
          minutes: null,
        },
        reservationNotMovedIn: {
          days: null,
          hours: null,
          mintues: null,
        },
      },
      eSignInsuranceForm: {
        sFormName: null,
      },
      eSignInsuranceFormName: "",
      eSignMoveInDocumentNames: [],
      eSignMoveInDocuments: [],
      includeFutureMoveOut: false,
      includeReservedUnitsInOccupied: true,
      insuranceEsignReturnUrl: "",
      insurancePolicyNumberRange: {
        end: null,
        start: null,
      },
      insurancePolicyNumberRefreshNum: null,
      insuranceSmsFollowUpContent: "",
      kioskUnitListing: "standard",
      notificationsFromName: "",
      notificationsReplyAddress: "",
      pickupEnabled: true,
      saveQuoteButtonText: "Save My Quote",
      requireAutobill: false,
      reservationExpireOccupancyValues: {
        bands: [
          {
            days: 30,
            from: 0,
            to: 100,
          },
        ],
        enabled: false,
      },
      saveQuotePopupText: "",
      resetPasswordUrl: "",
      sendReservationEmailOnFeeFailure: false,
      showMoveInDateLimitMessage: false,
      siteOpeningDate: null,
      tenantAccounts: {
        autoPayment: {
          enabled: true,
        },
        enableMultiSiteLogin: {
          enabled: false,
        },
        invoiceHistory: {
          enabled: true,
        },
        notification: {
          enabled: false,
          content: null,
          ctaButton: {
            text: null,
          },
        },
        makePayment: {
          enabled: true,
        },
        paymentHistory: {
          enabled: true,
        },
        tenantInfo: {
          enabled: true,
        },
        uploadDocuments: {
          enabled: true,
          generalContent:
            "Please select & upload the following documents as a pdf or image.",
          proofOfAddress: {
            content:
              "Please upload a photo which has proof of your current address. Examples are bank statement, credit card statement or utility bill.",
            enabled: true,
            label: "Proof of Address",
          },
          proofOfId: {
            content:
              "Please upload a photo of one of your identity documents such as your Driver's Licence or National Identity Card in JPG format.",
            enabled: true,
            label: "Proof of Identification",
          },
          proofOfInsurance: {
            content:
              "Please upload a document which has proof of you being insured for your declared amount.",
            enabled: true,
            label: "Proof of Insurance",
          },
        },
      },
      twilio: {
        accountSid: "",
        authToken: "",
        enabled: false,
        senderId: "",
      },
      useESignForInsuranceDocs: false,
      ccSiteEmailInSaveQuote: true,
      creditCardForAutobill: {
        enabled: true,
      },
      showPricesCreatesLead: false,
    },
    fees: {
      moveOutNotice: 7,
      lateDays: 15,
      lateFee: 20,
      adminFee: 49,
      nsfFee: 20,
      cleaningFee: "40",
      securityDeposit: 0,
    },
    token:
      "b6865a815dace7b10ab1c8dfb73e6ee512f02011dea374136b78385723099a0bbf5138757b9a3e2e006776a48e9f87f5",
    changedAt: "2020-11-25T13:06:51.750Z",
    changeToken:
      "cf297fd56d54fc1078a6768f38d91167f74c86a060ed72d1f740cd3fbb856af082dfcc87622e5618c58642633d99bc96",
    deleted: false,
    DivisionID: "11",
    LanguageID: "1",
    OwnerID: "11",
    friendlyName: null,
    pdfFonts: {
      lease: "Arial",
      insuranceDocs: "Arial",
      receipt: "Arial",
    },
  },
  {
    SiteID: 38626,
    sLocationCode: "L007",
    sGlobalSiteNum: "38626",
    iMobileType: "0",
    iRegionalOptions: 1,
    iOnLineChargeType: "0",
    iGMTTimeOffset: 10,
    sLocationDesc: null,
    sSiteIDCode: null,
    sSiteRegionCode: null,
    sContactName: "Shaun Bain",
    sEmailAddress: "wangara@keepsafestorage.com.au",
    sSiteName: "Keepsafe Storage - Wangara",
    sSiteAddr1: "69 Buckingham Dr",
    sSiteAddr2: null,
    sSiteCity: "Wangara",
    sSiteRegion: "WA",
    sSitePostalCode: "6065",
    sSiteCountry: "AUSTRALIA",
    sSitePhone: "08 9200 2262",
    sSiteFAX: "0",
    sWebSiteURL: "https://keepsafestorage.com.au/",
    iFeatMaxUnits: "750",
    bFeatGate: "true",
    bFeatKiosk: "true",
    bFeatRevMgmt: "true",
    bFeatCreditCards: "true",
    bFeatCorpOffice: "true",
    bFeatAccounting: "true",
    bFeatRecordStorage: "false",
    bFeatACH: "true",
    bFeatMobileStorage: "false",
    bFeatPromoAdvanced: "false",
    dACHStatus: "2019-11-14T08:51:21.25-05:00",
    bLiteVersion: "false",
    bTrial: "false",
    bSubscription: "false",
    bSiteDisabled: "false",
    dOvernightProcess: "2024-05-19T10:06:51.693-04:00",
    sLegalName: "BDST OPCO PTY LTD",
    bZipCodeData_Use: "false",
    dcLongitude: "115.8261220000",
    dcLatitude: "-31.7872930000",
    bClosedWeekdays: "false",
    bClosedSaturday: "false",
    bClosedSunday: "true",
    dWeekdayStrt: "2011-01-06T08:30:00-05:00",
    dWeekdayEnd: "2011-01-06T17:30:59-05:00",
    dSaturdayStrt: "2011-01-06T08:30:00-05:00",
    dSaturdayEnd: "2011-01-06T17:30:59-05:00",
    dSundayStrt: "2011-01-06T00:00:00-05:00",
    dSundayEnd: "2011-01-06T23:59:59-05:00",
    iIdentifier: "0",
    sIdentifier: null,
    bUseInclusiveTaxation: true,
    iBusinessType: "-32",
    iSiteDataType: "0",
    sTaxNumber: "44 648 410 655",
    iFacilityUsage: "0",
    iFacilityOwnership: "0",
    iFacilityMgmt: "0",
    iFacilityLocType: "0",
    iMobileBungoRules: "0",
    iOnLinePmtsAllowed: "1",
    iEdition: "1",
    iTerminalServices: "0",
    iDST: "0",
    dCreated: "2019-11-14T08:51:21.367-05:00",
    bPermanent: "false",
    bArchived: "false",
    dUpdated: "2024-05-19T14:06:51.693Z",
    uTS: "AAAAABA5F6c=",
    iVerboseLogging: "0",
    iSiteLinkStoreTier: "1",
    sSLBillingRef: "DQS007",
    iSubscriptionType: "0",
    tWeekdayStrt: "08:30:00",
    tWeekdayEnd: "17:30:59",
    tSaturdayStrt: "08:30:00",
    tSaturdayEnd: "17:30:59",
    tSundayStrt: "00:00:00",
    tSundayEnd: "23:59:59",
    rapidstorEnabled: true,
    dGateUpdated: "2024-05-15T13:44:43.18-04:00",
    bForcePushRates: "0",
    iWebRatesType: "0",
    ownerId: "11",
    languageId: "1",
    divisionId: "11",
    hours: {
      officeMondayOpen: "9:00am",
      officeTuesdayOpen: "9:00am",
      officeWednesdayOpen: "9:00am",
      officeThursdayOpen: "9:00am",
      officeFridayOpen: "9:00am",
      officeSaturdayOpen: "9:00am",
      officeSundayOpen: "Closed",
      officeMondayClose: "5:00pm",
      officeTuesdayClose: "5:00pm",
      officeWednesdayClose: "5:00pm",
      officeThursdayClose: "5:00pm",
      officeFridayClose: "5:00pm",
      officeSaturdayClose: "2:00pm",
      officeSundayClose: "",
      gateOpen: "24",
      gateClose: "Hours",
      gateOpenWeekend: "5:00am",
      gateCloseWeekend: "9:00pm",
      gateCloseSaturday: "Hours",
      gateCloseSunday: "Hours",
      gateOpenSaturday: "24",
      gateOpenSunday: "24",
    },
    skin: {
      accentColours: {
        primary: "#701605",
      },
      defaultUnitPicture: "https://ik.imagekit.io/bytcx9plm/3x3_f.png",
      mainColour: "#e02b0a",
      highlightColour: "#dddddd",
      moveinTimeRemaining: false,
    },
    administrative: {
      boxshopEnabled: true,
      testMode: false,
      rslite: false,
      rsliteKey: "N/A",
      refreshEnabled: false,
      availableForUse: false,
      insuranceEnabled: false,
      merchEnabled: false,
      carouselListing: false,
      useMtasForAuth: false,
    },
    rapidstor: {
      pushRate: true,
      siteLinkLeaseFields: [],
      marketingSurvey: {
        use: true,
        questions: {
          whereHearAboutUs: {
            display: true,
            required: true,
          },
          distanceFromFacility: {
            display: true,
            required: true,
          },
          whyStoring: {
            display: true,
            required: true,
          },
          customerType: {
            display: true,
            required: true,
          },
          whatStoring: {
            display: true,
            required: true,
          },
          whyStoringWithUs: {
            display: true,
            required: true,
          },
        },
      },
      country: "AU",
      unitListing: {
        sortOrder: {
          primary: "size",
          secondary: "price",
          tertiary: "availability",
        },
        useMultilevel: true,
      },
      siteLogo:
        "https://ik.imagekit.io/bytcx9plm/CDQS-L007-logo-ck2zg3gmz00068imo1o0riq4i.png",
      allowOriginUrl: ["https://keepsafestorage.com.au"],
      allowedCreditCardTypes: {
        visa: true,
        mastercard: true,
        amex: false,
      },
      facilitySelfService: {
        enquiries: {
          background:
            "https://ik.imagekit.io/bytcx9plm/facility-self-service-default-enquiries.png",
        },
        takePayment: {
          background:
            "https://ik.imagekit.io/bytcx9plm/facility-self-service-default-take-payment.png",
        },
        moveOut: {
          background:
            "https://ik.imagekit.io/bytcx9plm/facility-self-service-default-moveout.png",
        },
        boxshop: {
          background:
            "https://ik.imagekit.io/bytcx9plm/facility-self-service-default-boxshop.png",
        },
      },
      tieredPricing: {
        showTiersWithNoAvailableUnits: true,
        noAvailableUnitsText: "Call for Availability",
        cherryPickBasis: "lowestRate",
        hidePrices: false,
        hideQuickSearch: false,
        showPricesShowNeeded: true,
        showVehicleQuickSearch: false,
        showAvailableUnitsCount: false,
      },
      language: {
        selectionOption: "auto-detect",
      },
      useBoxShopCoupons: false,
      useDealCoupons: false,
      wizards: {
        moveinStandard: {
          requireAlternativeContactPhoneNumberField: true,
        },
        moveinSingle: {
          hideAlternativeContact: false,
          hideBoxshop: true,
          hideInsurance: false,
          insuranceRequired: false,
          hideDriversLicence: false,
          hideDriversLicenceState: true,
          hideDateOfBirth: false,
          hideState: false,
          hidePostalCode: false,
          allowSelfInsurance: false,
          insuranceManualEntry: false,
          requireAlternativeContactPhoneNumberField: true,
          hideInsurancePicker: false,
          allowIdUpload: true,
          allowProofOfAddressUpload: false,
          allowProofOfInsuranceUpload: false,
          insuranceAcceptancePopoverText: "",
          insuranceAcceptanceText:
            "By ticking this box you accept and agree; that the insurance coverage option selected will cover the true replacement value of your goods declared, agree to the T&C’s below and understand the inclusions/exclusions of the policy.",
          insuranceContent: "",
          insuranceContentPopoverText: "",
          insuranceManualEntryRequired: false,
          insuranceRefusedPopoverText: "",
          insuranceRefusedText:
            "By ticking this box, you are choosing not to be covered by insurance and acknowledge that we will not be held responsible for any damaged or lost goods during your rental period.",
        },
        reservationWithFeeStandard: {},
      },
      features: {
        "movein-wizard": "single-page",
        "unit-listing": "modern",
        boxshop: "standard",
        "reservation-with-fee-wizard": "standard",
        "tiered-unit-listing": "standard",
        "facility-self-service": "standard",
        "facility-staff-self-service": "standard",
        "tenant-accounts": "standard",
        "carousel-unit-listing": "standard",
      },
      forceTaxInclusive: false,
      sitelinkCostRetrieveChargeNameSubstiutions: [],
      enquiryAPI: {
        numOptions: 3,
      },
      paymentGateways: {
        use: false,
        gatewayToUse: "",
        paypal: {
          currency: "",
          clientId: "",
          clientSecret: "",
          useTestEnv: false,
          force3dsCheck: false,
        },
        paytabs: {
          merchantEmail: "",
          secretKey: "",
          merchantSiteUrl: "",
          countryCode: "",
          messageLanguage: "",
          merchantId: "",
        },
        paygate: {
          countryCode: "",
          currency: "",
          encryptionKey: "",
          locale: "",
          payMethod: "",
          paygateId: "",
        },
        paynamics: {
          countryCode: "PH",
          currency: "",
          merchantId: "",
          merchantKey: "",
          merchantTermsUrl: "",
          paymentMethods: ["cc", "bn", "gc", "pp", "dp"],
          secure3d: "try3d",
        },
        bypassSitelinkProcessing: false,
        r6Pay: {
          currency: "",
          useTestEnv: false,
          accessToken: "",
        },
      },
      minAvailableUnits: 0,
      hideUnitsMinAvailable: true,
      noAvailableUnitsText: "Call for Availability",
      quickReserveButtonText: "Quick Reserve",
      payNowButtonText: "Pay Now",
      payLaterButtonText: "Pay Later",
      hideQuickSearch: false,
      showVehicleQuickSearch: false,
      smallMediumSize: 8,
      mediumLargeSize: 14,
      moveinHideAcp: false,
      insuranceRequired: false,
      hideBoxshop: true,
      hideInsurance: false,
      hideLicense: false,
      hideLicenseState: true,
      hideDateOfBirth: true,
      hideState: false,
      hidePostalCode: false,
      autoOptInSms: true,
      currencySymbol: "$",
      sizeSymbol: "m",
      groundFloor: 0,
      billingDefault: "MonthlyAnniversary",
      shippingEnabled: false,
      legacyPickupLocationsEnabled: false,
      legacyPickupLocations: null,
      shippingInventoryItem: null,
      freeShippingDealEnabled: false,
      freeShippingDealAmount: 150,
      allowReservation: false,
      allowMoveIn: true,
      reservationNumberOfDaysInAdvanceLimit: 7,
      moveinNumberOfDaysInAdvanceLimit: 14,
      reservationNumberOfDaysInAdvanceChargeFee: 0,
      reservationExpireReservationDays: "7",
      assistanceMoving: false,
      assistanceMovingEmailAddress: "",
      notificationsFromAddress: "wangara@keepsafestorage.com.au",
      notificationsAdditionalCcAddresses: [],
      completeMoveinUrl: "",
      useESign: true,
      useAutoBilling: true,
      autoBillCheckedByDefault: false,
      doNotSendInvoiceSiteLinkWhenAutoBill: false,
      areaSizeSymbol: "m²",
      attachLeaseToMoveInConfirmationEmail: false,
      attachReceiptToMoveInConfirmationEmail: true,
      autoOptInSMS: false,
      bookOnlineDiscount: 0,
      completeMoveinURL: "",
      hidePrices: false,
      insuranceCustomFormat: "",
      moveinHideACP: false,
      notificationsAdditionalCCAddresses: [],
      showAutobillTerms: false,
      showPricesButtonText: "Show Prices",
      showPricesShowNeeded: true,
      showWeeklyRates: false,
      useWebRates: false,
      checkForExistingTenant: false,
      dateFormat: "dd-MM-yyyy",
      eSignReturnUrl: "https://keepsafestorage.com.au/booking-confirmation/",
      locationPageUrl: "",
      moveinEmailSubject: "",
      moveinRedirectUrl:
        "https://keepsafestorage.com.au/book-a-unit/locations/wangara/book-confirmed",
      notificationsAdditionalBCCAddresses: [],
      recaptcha: {
        enabled: true,
        secretKey: "6Lf5GTwoAAAAAOvne7oKNDKEOmGBpxPkkjeS927u",
        siteKey: "6Lf5GTwoAAAAACOg3xVeVHJlt9MiGuzR7MI48VgM",
        tolerance: 0.5,
      },
      reservationEmailSubject: "",
      reservationPopupText: "",
      scheduleFollowUpEmails: true,
      showAreaInsteadOfDimensions: false,
      spaceCalculatorValues: {
        bedroom: 4,
        box: 0.05,
        garage: 7,
        highestValue: {
          area: 20,
          high: 30,
          low: 18,
        },
        largeItem: 1.5,
        largeRoom: 5,
        lowestValue: {
          area: 3,
          high: 5,
          low: 1,
        },
        room: 4,
        smallItem: 0.5,
        smallRoom: 3,
      },
      useDescriptorTitle: false,
      webhooks: {
        moveIn: {
          enabled: false,
          template: "",
          url: "",
        },
        pageLoad: {
          enabled: false,
          template: "",
          url: "",
        },
        reservation: {
          enabled: false,
          template: "",
          url: "",
        },
        reservationWithFee: {
          enabled: false,
          template: "",
          url: "",
        },
        docUpload: {
          enabled: false,
          template: "",
          url: "",
        },
        leadFollowUp: {
          enabled: false,
          template: "",
          url: "",
        },
        enquiry: {
          enabled: false,
          template: "",
          url: "",
        },
      },
      currency: "AUD",
      autoESignRedirect: true,
      boxshopPurchaseAttachmentName: "",
      boxshopPurchaseEmailSubject: "",
      notificationsReplyAddress: "",
      reservationExpireOccupancyValues: {
        bands: [
          {
            from: 0,
            to: 100,
            days: 30,
          },
        ],
        enabled: false,
      },
      tenantAccounts: {
        autoPayment: {
          enabled: true,
        },
        invoiceHistory: {
          enabled: true,
        },
        makePayment: {
          enabled: true,
        },
        paymentHistory: {
          enabled: true,
        },
        tenantInfo: {
          enabled: true,
        },
        uploadIdentification: {
          enabled: true,
        },
        uploadDocuments: {
          enabled: true,
          generalContent:
            "Please select & upload the following documents as a pdf or image.",
          proofOfAddress: {
            content:
              "Please upload a photo which has proof of your current address. Examples are bank statement, credit card statement or utility bill.",
            enabled: true,
            label: "Proof of Address",
          },
          proofOfId: {
            content:
              "Please upload a photo of one of your identity documents such as your Driver's Licence or National Identity Card in JPG format.",
            enabled: true,
            label: "Proof of Identification",
          },
          proofOfInsurance: {
            content:
              "Please upload a document which has proof of you being insured for your declared amount.",
            enabled: true,
            label: "Proof of Insurance",
          },
        },
        notification: {
          content: null,
          ctaButton: {
            text: null,
          },
          enabled: false,
        },
        enableMultiSiteLogin: {
          enabled: false,
        },
      },
      allowReservationsWhenNoAvailability: false,
      boxshopCategoryAlphaOrder: false,
      boxshopTermsConditions: "",
      datesClosed: "",
      eSignInsuranceFormName: "",
      eSignMoveInDocumentNames: [],
      eSignMoveInDocuments: [],
      includeFutureMoveOut: false,
      includeReservedUnitsInOccupied: true,
      insuranceEsignReturnUrl: "",
      pickupEnabled: true,
      resetPasswordUrl: "",
      showMoveInDateLimitMessage: false,
      useESignForInsuranceDocs: false,
      attachInsuranceDocsToMoveInConfirmationEmail: false,
      delayedInsurance: {
        enabled: false,
        timings: {
          days: null,
          hours: null,
          minutes: null,
        },
      },
      documentVerification: {
        enabled: false,
        providerToUse: null,
        providers: {
          rapidId: {
            label: "RapidID",
            token: null,
          },
        },
      },
      eSignInsuranceForm: {
        sFormName: null,
      },
      emailSchedules: {
        quoteUnlockFirstReminder: {
          days: null,
          hours: null,
          minutes: null,
        },
        quoteUnlockSecondReminder: {
          days: null,
          hours: null,
          minutes: null,
        },
        reservationNotMovedIn: {
          days: 0,
          hours: 0,
          mintues: null,
          minutes: 20,
        },
        quoteEmail: {
          1: {
            subject: "Your Storage Quote",
          },
          2: {
            days: 0,
            hours: 0,
            minutes: 0,
            subject: "Did you forget something?",
          },
          3: {
            days: 0,
            hours: 0,
            minutes: 0,
            subject: "Don't miss out!",
          },
        },
      },
      insurancePolicyNumberRange: {
        end: null,
        start: null,
      },
      insurancePolicyNumberRefreshNum: null,
      insuranceSmsFollowUpContent: "",
      kioskUnitListing: "standard",
      notificationsFromName: "Keepsafe Storage",
      siteOpeningDate: null,
      twilio: {
        accountSid: "",
        authToken: "",
        enabled: false,
        senderId: "",
      },
      directDebit: {
        creditAmount: 0,
        enabled: false,
      },
      requireAutobill: false,
      sendReservationEmailOnFeeFailure: false,
      allowSaveQuote: true,
      saveQuoteButtonText: "Save My Quote",
      saveQuotePopupText: "",
      ccSiteEmailInSaveQuote: false,
      creditCardForAutobill: {
        enabled: true,
      },
      showPricesCreatesLead: false,
    },
    fees: {
      moveOutNotice: 7,
      lateDays: 15,
      lateFee: 20,
      adminFee: 49,
      nsfFee: 15,
      cleaningFee: "40",
      securityDeposit: 0,
    },
    token:
      "e64c515e0fd0b89fc40a3bf5fb348556236c6f6f8a9b2698fe1ea7b33949b7318756c3c59e604b2ea19446ec2fbd8a81",
    changedAt: "2024-05-19T18:04:54.877Z",
    changeToken:
      "4ff1a356225c89b1f88e0a2c95c305595a4d6d13cd8f88bbe67b08a096f8da366d3379e4b3704061f9d900cb9a408c0e",
    deleted: false,
    DivisionID: "11",
    LanguageID: "1",
    OwnerID: "11",
    pdfFonts: {
      lease: "Arial",
      receipt: "Arial",
      insuranceDocs: "Arial",
    },
    scaConfiguration: {},
    collections: {
      unitTypeGroup: {
        name: "unitTypeGroup",
        job: "CDQS/L007/unitTypeGroup",
        status: "finished",
        timestamp: 1715992228921,
      },
      chargeDescription: {
        name: "chargeDescription",
        job: "CDQS/L007/chargeDescription",
        status: "finished",
        timestamp: 1715992228922,
      },
      paymentTypes: {
        name: "paymentTypes",
        job: "CDQS/L007/paymentTypes",
        status: "finished",
        timestamp: 1715992228922,
      },
      insuranceCoverage: {
        name: "insuranceCoverage",
        job: "CDQS/L007/insuranceCoverage",
        status: "finished",
        timestamp: 1715992228922,
      },
      discountPlan: {
        name: "discountPlan",
        job: "CDQS/L007/discountPlan",
        status: "finished",
        timestamp: 1715992228922,
      },
      inventory: {
        name: "inventory",
        job: "CDQS/L007/inventory",
        status: "finished",
        timestamp: 1715992228922,
      },
      paymentSettings: {
        name: "paymentSettings",
        job: "CDQS/L007/paymentSettings",
        status: "finished",
        timestamp: 1715992228922,
      },
      unitsFull: {
        name: "unitsFull",
        job: "CDQS/L007/unitsFull",
        status: "finished",
        timestamp: 1715992228920,
      },
      site: {
        name: "site",
        job: "CDQS/L007/site",
        status: "finished",
        timestamp: 1715992228922,
      },
      form: {
        name: "form",
        job: "CDQS/L007/form",
        status: "finished",
        timestamp: 1715992228922,
      },
      marketingSource: {
        name: "marketingSource",
        job: "CDQS/L007/marketingSource",
        status: "finished",
        timestamp: 1715992228922,
      },
    },
    friendlyName: null,
    originalName: "Keepsafe Storage - Wangara",
    personas: [],
    sCorpCode: "CDQS",
  },
  {
    SiteID: 50762,
    OwnerID: "11",
    LanguageID: "1",
    sLocationCode: "L008",
    sGlobalSiteNum: "50762",
    iMobileType: "0",
    iRegionalOptions: 1,
    iOnLineChargeType: "0",
    iGMTTimeOffset: 8,
    sLocationDesc: "Test",
    sSiteIDCode: null,
    sSiteRegionCode: null,
    sContactName: "Graham Moffitt",
    sEmailAddress: "waroona@keepsafestorage.com.au",
    sSiteName: "Keepsafe Storage Waroona",
    sSiteAddr1: "3 McDowell Street",
    sSiteAddr2: null,
    sSiteCity: "Waroona",
    sSiteRegion: "WA",
    sSitePostalCode: "6215",
    sSiteCountry: "AUS",
    sSitePhone: "08 9733 2959",
    sSiteFAX: ".",
    sWebSiteURL: "keepsafestorage.com.au",
    iFeatMaxUnits: "250",
    bFeatGate: "true",
    bFeatKiosk: "true",
    bFeatRevMgmt: "true",
    bFeatCreditCards: "true",
    bFeatCorpOffice: "true",
    bFeatAccounting: "true",
    bFeatRecordStorage: "false",
    bFeatACH: "true",
    bFeatMobileStorage: "false",
    bFeatPromoAdvanced: "false",
    dACHStatus: "2023-08-23T20:59:24.253-04:00",
    bLiteVersion: "false",
    bTrial: "false",
    bSubscription: "false",
    bSiteDisabled: "false",
    dOvernightProcess: "2024-05-18T12:03:40.683-04:00",
    sLegalName: null,
    bZipCodeData_Use: "false",
    dcLongitude: "115.9197280000",
    dcLatitude: "-32.8367090000",
    bClosedWeekdays: "false",
    bClosedSaturday: "false",
    bClosedSunday: "false",
    dWeekdayStrt: "2011-01-06T00:00:00-05:00",
    dWeekdayEnd: "2011-01-06T23:59:59-05:00",
    dSaturdayStrt: "2011-01-06T00:00:00-05:00",
    dSaturdayEnd: "2011-01-06T23:59:59-05:00",
    dSundayStrt: "2011-01-06T00:00:00-05:00",
    dSundayEnd: "2011-01-06T23:59:59-05:00",
    iIdentifier: "0",
    sIdentifier: null,
    bUseInclusiveTaxation: true,
    iBusinessType: "-999",
    iSiteDataType: "0",
    sTaxNumber: null,
    iFacilityUsage: "0",
    iFacilityOwnership: "0",
    iFacilityMgmt: "0",
    iFacilityLocType: "0",
    iMobileBungoRules: "0",
    iOnLinePmtsAllowed: "1",
    iEdition: "1",
    iTerminalServices: "0",
    iDST: "0",
    dCreated: "2023-08-23T20:59:24.443-04:00",
    bPermanent: "false",
    bArchived: "false",
    dUpdated: "2024-05-18T16:03:40.683Z",
    uTS: "AAAAABA44yw=",
    DivisionID: "11",
    iVerboseLogging: "0",
    iSiteLinkStoreTier: "1",
    sSLBillingRef: null,
    iSubscriptionType: "0",
    bForcePushRates: "0",
    iWebRatesType: "0",
    tWeekdayStrt: "00:00:00",
    tWeekdayEnd: "23:59:59",
    tSaturdayStrt: "00:00:00",
    tSaturdayEnd: "23:59:59",
    tSundayStrt: "00:00:00",
    tSundayEnd: "23:59:59",
    rapidstorEnabled: true,
    administrative: {
      availableForUse: false,
      boxshopEnabled: true,
      carouselListing: false,
      insuranceEnabled: false,
      merchEnabled: false,
      refreshEnabled: false,
      rslite: false,
      rsliteKey: "N/A",
      testMode: false,
      useMtasForAuth: false,
    },
    fees: {
      adminFee: 49,
      cleaningFee: "40",
      lateDays: 15,
      lateFee: 20,
      moveOutNotice: 7,
      nsfFee: 15,
      securityDeposit: 0,
    },
    friendlyName: "Keepsafe Storage Waroona",
    hours: {
      gateClose: "Hours",
      gateCloseSaturday: "Hours",
      gateCloseSunday: "Hours",
      gateOpen: "24",
      gateOpenSaturday: "24",
      gateOpenSunday: "24",
      officeFridayClose: "5:00pm",
      officeFridayOpen: "9:00am",
      officeMondayClose: "5:00pm",
      officeMondayOpen: "9:00am",
      officeSaturdayClose: "2:00pm",
      officeSaturdayOpen: "9:00am",
      officeSundayClose: "",
      officeSundayOpen: "Closed",
      officeThursdayClose: "5:00pm",
      officeThursdayOpen: "9:00am",
      officeTuesdayClose: "5:00pm",
      officeTuesdayOpen: "9:00am",
      officeWednesdayClose: "5:00pm",
      officeWednesdayOpen: "9:00am",
    },
    pdfFonts: {
      lease: "Arial",
      insuranceDocs: "Arial",
      receipt: "Arial",
    },
    rapidstor: {
      allowedCreditCardTypes: {
        amex: false,
        mastercard: true,
        visa: true,
      },
      allowMoveIn: true,
      allowOriginUrl: [],
      allowSaveQuote: true,
      allowReservation: false,
      allowReservationsWhenNoAvailability: false,
      areaSizeSymbol: "m²",
      assistanceMoving: false,
      assistanceMovingEmailAddress: "",
      attachLeaseToMoveInConfirmationEmail: false,
      attachReceiptToMoveInConfirmationEmail: true,
      attachInsuranceDocsToMoveInConfirmationEmail: false,
      autoBillCheckedByDefault: false,
      autoESignRedirect: true,
      autoOptInSMS: false,
      billingDefault: "MonthlyAnniversary",
      bookOnlineDiscount: 0,
      boxshopCategoryAlphaOrder: false,
      boxshopPurchaseAttachmentName: "",
      boxshopPurchaseEmailSubject: "",
      boxshopTermsConditions: "",
      checkForExistingTenant: false,
      completeMoveinUrl: "",
      country: "AU",
      currency: "AUD",
      currencySymbol: "$",
      dateFormat: "dd-MM-yyyy",
      datesClosed: "",
      delayedInsurance: {
        enabled: false,
        timings: {
          days: null,
          hours: null,
          minutes: null,
        },
      },
      directDebit: {
        enabled: false,
        creditAmount: 0,
      },
      documentVerification: {
        enabled: false,
        providerToUse: null,
        providers: {
          rapidId: {
            label: "RapidID",
            token: null,
          },
        },
      },
      doNotSendInvoiceSiteLinkWhenAutoBill: false,
      emailSchedules: {
        quoteEmail: {
          1: {
            subject: "Your Storage Quote",
          },
          2: {
            subject: "Did you forget something?",
            days: 5,
            hours: 0,
            minutes: 1,
          },
          3: {
            subject: "Don't miss out!",
            days: 2,
            hours: 0,
            minutes: 1,
          },
        },
        quoteUnlockFirstReminder: {
          days: null,
          hours: null,
          minutes: null,
        },
        quoteUnlockSecondReminder: {
          days: null,
          hours: null,
          minutes: null,
        },
        reservationNotMovedIn: {
          days: 0,
          hours: 0,
          mintues: null,
          minutes: 20,
        },
      },
      enquiryAPI: {
        numOptions: 3,
      },
      eSignInsuranceForm: {
        sFormName: null,
      },
      eSignInsuranceFormName: "",
      eSignMoveInDocumentNames: [],
      eSignMoveInDocuments: [],
      eSignReturnUrl: "",
      facilitySelfService: {
        boxshop: {
          background:
            "https://ik.imagekit.io/bytcx9plm/facility-self-service-default-boxshop.png",
        },
        enquiries: {
          background:
            "https://ik.imagekit.io/bytcx9plm/facility-self-service-default-enquiries.png",
        },
        moveOut: {
          background:
            "https://ik.imagekit.io/bytcx9plm/facility-self-service-default-moveout.png",
        },
        takePayment: {
          background:
            "https://ik.imagekit.io/bytcx9plm/facility-self-service-default-take-payment.png",
        },
      },
      features: {
        boxshop: "standard",
        "carousel-unit-listing": "standard",
        "facility-self-service": "standard",
        "facility-staff-self-service": "standard",
        "movein-wizard": "single-page",
        "reservation-with-fee-wizard": "standard",
        "tenant-accounts": "standard",
        "tiered-unit-listing": "standard",
        "unit-listing": "modern",
      },
      forceTaxInclusive: false,
      freeShippingDealAmount: 150,
      freeShippingDealEnabled: false,
      groundFloor: "0",
      hideBoxshop: false,
      hideDateOfBirth: true,
      hideInsurance: false,
      hideLicense: false,
      hideLicenseState: true,
      hidePostalCode: false,
      hidePrices: false,
      hideQuickSearch: false,
      hideState: false,
      hideUnitsMinAvailable: false,
      includeFutureMoveOut: false,
      includeReservedUnitsInOccupied: true,
      insuranceCustomFormat: "",
      insuranceEsignReturnUrl: "",
      insurancePolicyNumberRange: {
        end: null,
        start: null,
      },
      insurancePolicyNumberRefreshNum: null,
      insuranceRequired: false,
      insuranceSmsFollowUpContent: "",
      kioskUnitListing: "standard",
      language: {
        selectionOption: "auto-detect",
      },
      legacyPickupLocations: null,
      legacyPickupLocationsEnabled: false,
      locationPageUrl: "",
      marketingSurvey: {
        questions: {
          customerType: {
            display: true,
            required: true,
          },
          distanceFromFacility: {
            display: true,
            required: true,
          },
          whatStoring: {
            display: true,
            required: true,
          },
          whereHearAboutUs: {
            display: true,
            required: true,
          },
          whyStoring: {
            display: true,
            required: true,
          },
          whyStoringWithUs: {
            display: true,
            required: true,
          },
        },
        use: true,
      },
      mediumLargeSize: 14,
      minAvailableUnits: 0,
      moveinEmailSubject: "",
      moveinHideACP: false,
      moveinNumberOfDaysInAdvanceLimit: 14,
      moveinRedirectUrl:
        "https://keepsafestorage.com.au/book-a-unit/locations/waroona/book-confirmed",
      noAvailableUnitsText: "Call for Availability",
      notificationsAdditionalBCCAddresses: [],
      notificationsAdditionalCCAddresses: [],
      notificationsFromAddress: "waroona@keepsafestorage.com.au",
      notificationsFromName: "Keepsafe Storage",
      notificationsReplyAddress: "",
      payLaterButtonText: "Pay Later",
      paymentGateways: {
        bypassSitelinkProcessing: false,
        gatewayToUse: "",
        paygate: {
          countryCode: "",
          currency: "",
          encryptionKey: "",
          locale: "",
          paygateId: "",
          payMethod: "",
        },
        paynamics: {
          countryCode: "PH",
          currency: "",
          merchantId: "",
          merchantKey: "",
          merchantTermsUrl: "",
          paymentMethods: ["bn", "cc", "dp", "gc", "pp"],
          secure3d: "try3d",
        },
        paypal: {
          clientId: "",
          clientSecret: "",
          currency: "",
          useTestEnv: false,
          force3dsCheck: false,
        },
        paytabs: {
          countryCode: "",
          merchantEmail: "",
          merchantId: "",
          merchantSiteUrl: "",
          messageLanguage: "",
          secretKey: "",
        },
        use: false,
        r6Pay: {
          currency: "",
          useTestEnv: false,
          accessToken: "",
        },
      },
      payNowButtonText: "Pay Now",
      pickupEnabled: true,
      pushRate: true,
      quickReserveButtonText: "Quick Reserve",
      saveQuoteButtonText: "Save My Quote",
      recaptcha: {
        enabled: true,
        secretKey: "6Lf5GTwoAAAAAOvne7oKNDKEOmGBpxPkkjeS927u",
        siteKey: "6Lf5GTwoAAAAACOg3xVeVHJlt9MiGuzR7MI48VgM",
        tolerance: 0.5,
      },
      requireAutobill: false,
      reservationEmailSubject: "",
      reservationExpireOccupancyValues: {
        bands: [
          {
            days: 30,
            from: 0,
            to: 100,
          },
        ],
        enabled: false,
      },
      reservationExpireReservationDays: "7",
      reservationNumberOfDaysInAdvanceChargeFee: 0,
      reservationNumberOfDaysInAdvanceLimit: 7,
      reservationPopupText: "",
      saveQuotePopupText: "",
      resetPasswordUrl: "",
      scheduleFollowUpEmails: true,
      sendReservationEmailOnFeeFailure: false,
      shippingEnabled: false,
      shippingInventoryItem: null,
      showAreaInsteadOfDimensions: false,
      showAutobillTerms: false,
      showMoveInDateLimitMessage: false,
      showPricesButtonText: "Show Prices",
      showPricesShowNeeded: true,
      showVehicleQuickSearch: false,
      showWeeklyRates: false,
      sitelinkCostRetrieveChargeNameSubstiutions: [],
      siteLinkLeaseFields: [],
      siteLogo: "https://ik.imagekit.io/bytcx9plm/sitelogo.png",
      siteOpeningDate: null,
      sizeSymbol: "m",
      smallMediumSize: 8,
      spaceCalculatorValues: {
        bedroom: 4,
        box: 0.05,
        garage: 7,
        highestValue: {
          area: 20,
          high: 30,
          low: 18,
        },
        largeItem: 1.5,
        largeRoom: 5,
        lowestValue: {
          area: 3,
          high: 5,
          low: 1,
        },
        room: 4,
        smallItem: 0.5,
        smallRoom: 3,
      },
      tenantAccounts: {
        autoPayment: {
          enabled: true,
        },
        enableMultiSiteLogin: {
          enabled: false,
        },
        invoiceHistory: {
          enabled: true,
        },
        notification: {
          enabled: false,
          content: null,
          ctaButton: {
            text: null,
          },
        },
        makePayment: {
          enabled: true,
        },
        paymentHistory: {
          enabled: true,
        },
        tenantInfo: {
          enabled: false,
        },
        uploadDocuments: {
          enabled: true,
          generalContent:
            "Please select & upload the following documents as a pdf or image.",
          proofOfAddress: {
            content:
              "Please upload a photo which has proof of your current address. Examples are bank statement, credit card statement or utility bill.",
            enabled: false,
            label: "Proof of Address",
          },
          proofOfId: {
            content:
              "Please upload a photo of one of your identity documents such as your Driver's Licence or National Identity Card in JPG format.",
            enabled: true,
            label: "Proof of Identification",
          },
          proofOfInsurance: {
            content:
              "Please upload a document which has proof of you being insured for your declared amount.",
            enabled: false,
            label: "Proof of Insurance",
          },
        },
      },
      tieredPricing: {
        cherryPickBasis: "lowestRate",
        hidePrices: false,
        hideQuickSearch: false,
        noAvailableUnitsText: "Call for Availability",
        showAvailableUnitsCount: false,
        showPricesShowNeeded: true,
        showTiersWithNoAvailableUnits: true,
        showVehicleQuickSearch: false,
      },
      twilio: {
        accountSid: "",
        authToken: "",
        enabled: false,
        senderId: "",
      },
      unitListing: {
        sortOrder: {
          primary: "size",
          secondary: "price",
          tertiary: "availability",
        },
        useMultilevel: true,
      },
      useAutoBilling: true,
      useBoxShopCoupons: false,
      useDealCoupons: false,
      useDescriptorTitle: false,
      useESign: true,
      useESignForInsuranceDocs: false,
      useWebRates: false,
      webhooks: {
        docUpload: {
          enabled: false,
          template: "",
          url: "",
        },
        moveIn: {
          enabled: false,
          template: "",
          url: "",
        },
        pageLoad: {
          enabled: false,
          template: "",
          url: "",
        },
        reservation: {
          enabled: false,
          template: "",
          url: "",
        },
        reservationWithFee: {
          enabled: false,
          template: "",
          url: "",
        },
        leadFollowUp: {
          enabled: false,
          template: "",
          url: "",
        },
        enquiry: {
          enabled: false,
          template: "",
          url: "",
        },
      },
      wizards: {
        moveinSingle: {
          allowIdUpload: true,
          allowProofOfAddressUpload: false,
          allowProofOfInsuranceUpload: false,
          hideAlternativeContact: false,
          hideBoxshop: true,
          hideDateOfBirth: false,
          hideDriversLicence: false,
          hideDriversLicenceState: true,
          hideInsurance: false,
          hideInsurancePicker: false,
          hidePostalCode: false,
          hideState: false,
          insuranceAcceptancePopoverText: "",
          insuranceAcceptanceText:
            "By ticking this box you accept and agree; that the insurance coverage option selected will cover the true replacement value of your goods declared, agree to the T&C’s below and understand the inclusions/exclusions of the policy.",
          insuranceContent: "",
          insuranceContentPopoverText: "",
          insuranceManualEntry: false,
          insuranceManualEntryRequired: false,
          insuranceRefusedPopoverText: "",
          insuranceRefusedText:
            "By ticking this box, you are choosing not to be covered by insurance and acknowledge that we will not be held responsible for any damaged or lost goods during your rental period.",
          insuranceRequired: false,
          requireAlternativeContactPhoneNumberField: true,
        },
        moveinStandard: {
          requireAlternativeContactPhoneNumberField: true,
        },
        reservationWithFeeStandard: {},
      },
      ccSiteEmailInSaveQuote: false,
      creditCardForAutobill: {
        enabled: true,
      },
      showPricesCreatesLead: false,
    },
    skin: {
      accentColours: {
        primary: "#701605",
      },
      defaultUnitPicture: "https://ik.imagekit.io/bytcx9plm/3x3_f.png",
      highlightColour: "#dddddd",
      mainColour: "#e02b0a",
      moveinTimeRemaining: false,
    },
    token:
      "2c28fc7531a3afcba707be757b5f41f3076c61828f57fc62bf7c21b3f00c2ad8d54167873a91345f5098c42605e10fd7",
    changeToken:
      "3b7370c4c9635660e82750da8b620437a9542a818da233aa54ee4612a0815dc9c720ab15536bd40ca418a8cb806f61f7",
    changedAt: "2024-05-19T02:50:34.064Z",
    deleted: false,
    originalName: "KeepSafe Storage Express",
    scaConfiguration: {},
    collections: {
      site: {
        name: "site",
        job: "CDQS/L008/site",
        status: "finished",
        timestamp: 1715992228923,
      },
      form: {
        name: "form",
        job: "CDQS/L008/form",
        status: "finished",
        timestamp: 1715992228926,
      },
      inventory: {
        name: "inventory",
        job: "CDQS/L008/inventory",
        status: "finished",
        timestamp: 1716077494260,
      },
      unitTypeGroup: {
        name: "unitTypeGroup",
        job: "CDQS/L008/unitTypeGroup",
        status: "finished",
        timestamp: 1715992228923,
      },
      unitsFull: {
        name: "unitsFull",
        job: "CDQS/L008/unitsFull",
        status: "finished",
        timestamp: 1715992228923,
      },
      discountPlan: {
        name: "discountPlan",
        job: "CDQS/L008/discountPlan",
        status: "finished",
        timestamp: 1715992228926,
      },
      paymentTypes: {
        name: "paymentTypes",
        job: "CDQS/L008/paymentTypes",
        status: "finished",
        timestamp: 1715992228926,
      },
      insuranceCoverage: {
        name: "insuranceCoverage",
        job: "CDQS/L008/insuranceCoverage",
        status: "finished",
        timestamp: 1715992228925,
      },
      marketingSource: {
        name: "marketingSource",
        job: "CDQS/L008/marketingSource",
        status: "finished",
        timestamp: 1715992228926,
      },
      paymentSettings: {
        name: "paymentSettings",
        job: "CDQS/L008/paymentSettings",
        status: "finished",
        timestamp: 1715992228926,
      },
      chargeDescription: {
        name: "chargeDescription",
        job: "CDQS/L008/chargeDescription",
        status: "finished",
        timestamp: 1715992228923,
      },
    },
    personas: [],
    sCorpCode: "CDQS",
  },
  {
    SiteID: 52877,
    OwnerID: "11",
    LanguageID: "1",
    sLocationCode: "L009",
    sGlobalSiteNum: "52877",
    iMobileType: "0",
    iRegionalOptions: 1,
    iOnLineChargeType: "0",
    iGMTTimeOffset: 8,
    sLocationDesc: "Test",
    sSiteIDCode: null,
    sSiteRegionCode: null,
    sContactName: "Graham Moffit",
    sEmailAddress: null,
    sSiteName: "Keepsafe Storage Exmouth",
    sSiteAddr1: "65 Ingram Street",
    sSiteAddr2: null,
    sSiteCity: "Northwest Cape",
    sSiteRegion: "WA",
    sSitePostalCode: "6707",
    sSiteCountry: "AUS",
    sSitePhone: null,
    sSiteFAX: null,
    sWebSiteURL: "www.sitelink.com",
    iFeatMaxUnits: "100",
    bFeatGate: "true",
    bFeatKiosk: "true",
    bFeatRevMgmt: "true",
    bFeatCreditCards: "true",
    bFeatCorpOffice: "true",
    bFeatAccounting: "true",
    bFeatRecordStorage: "false",
    bFeatACH: "true",
    bFeatMobileStorage: "false",
    bFeatPromoAdvanced: "false",
    dACHStatus: "2024-04-16T19:42:04.26-04:00",
    bLiteVersion: "false",
    bTrial: "false",
    bSubscription: "false",
    bSiteDisabled: "false",
    dOvernightProcess: "2024-05-18T12:04:14.513-04:00",
    sLegalName: null,
    bZipCodeData_Use: "false",
    dcLongitude: "114.1215700000",
    dcLatitude: "-22.0092480000",
    bClosedWeekdays: "false",
    bClosedSaturday: "false",
    bClosedSunday: "false",
    dWeekdayStrt: "2011-01-06T00:00:00-05:00",
    dWeekdayEnd: "2011-01-06T23:59:59-05:00",
    dSaturdayStrt: "2011-01-06T00:00:00-05:00",
    dSaturdayEnd: "2011-01-06T23:59:59-05:00",
    dSundayStrt: "2011-01-06T00:00:00-05:00",
    dSundayEnd: "2011-01-06T23:59:59-05:00",
    iIdentifier: "0",
    sIdentifier: null,
    bUseInclusiveTaxation: true,
    iBusinessType: "-999",
    iSiteDataType: "0",
    sTaxNumber: null,
    iFacilityUsage: "0",
    iFacilityOwnership: "0",
    iFacilityMgmt: "0",
    iFacilityLocType: "0",
    iMobileBungoRules: "0",
    iOnLinePmtsAllowed: "1",
    iEdition: "1",
    iTerminalServices: "0",
    iDST: "0",
    dCreated: "2024-04-16T19:42:04.513-04:00",
    bPermanent: "false",
    bArchived: "false",
    dUpdated: "2024-05-18T16:04:14.513Z",
    uTS: "AAAAABA45Ms=",
    DivisionID: "11",
    iVerboseLogging: "0",
    iSiteLinkStoreTier: "1",
    sSLBillingRef: null,
    iSubscriptionType: "0",
    bForcePushRates: "0",
    iWebRatesType: "0",
    tWeekdayStrt: "00:00:00",
    tWeekdayEnd: "23:59:59",
    tSaturdayStrt: "00:00:00",
    tSaturdayEnd: "23:59:59",
    tSundayStrt: "00:00:00",
    tSundayEnd: "23:59:59",
    rapidstorEnabled: true,
    administrative: {
      availableForUse: false,
      boxshopEnabled: true,
      carouselListing: false,
      insuranceEnabled: false,
      merchEnabled: false,
      refreshEnabled: false,
      rslite: false,
      rsliteKey: "N/A",
      testMode: false,
      useMtasForAuth: false,
    },
    fees: {
      adminFee: 49,
      cleaningFee: "40",
      lateDays: 15,
      lateFee: 20,
      moveOutNotice: 7,
      nsfFee: 15,
      securityDeposit: 0,
    },
    friendlyName: "Keepsafe Storage Exmouth",
    hours: {
      gateClose: "Hours",
      gateCloseSaturday: "Hours",
      gateCloseSunday: "Hours",
      gateOpen: "24",
      gateOpenSaturday: "24",
      gateOpenSunday: "24",
      officeFridayClose: "5:00pm",
      officeFridayOpen: "9:00am",
      officeMondayClose: "5:00pm",
      officeMondayOpen: "9:00am",
      officeSaturdayClose: "2:00pm",
      officeSaturdayOpen: "9:00am",
      officeSundayClose: "",
      officeSundayOpen: "Closed",
      officeThursdayClose: "5:00pm",
      officeThursdayOpen: "9:00am",
      officeTuesdayClose: "5:00pm",
      officeTuesdayOpen: "9:00am",
      officeWednesdayClose: "5:00pm",
      officeWednesdayOpen: "9:00am",
    },
    pdfFonts: {
      lease: "Arial",
      insuranceDocs: "Arial",
      receipt: "Arial",
    },
    rapidstor: {
      allowedCreditCardTypes: {
        amex: false,
        mastercard: true,
        visa: true,
      },
      allowMoveIn: true,
      allowOriginUrl: [],
      allowSaveQuote: true,
      allowReservation: false,
      allowReservationsWhenNoAvailability: false,
      areaSizeSymbol: "m²",
      assistanceMoving: false,
      assistanceMovingEmailAddress: "",
      attachLeaseToMoveInConfirmationEmail: false,
      attachReceiptToMoveInConfirmationEmail: true,
      attachInsuranceDocsToMoveInConfirmationEmail: false,
      autoBillCheckedByDefault: false,
      autoESignRedirect: true,
      autoOptInSMS: false,
      billingDefault: "MonthlyAnniversary",
      bookOnlineDiscount: 0,
      boxshopCategoryAlphaOrder: false,
      boxshopPurchaseAttachmentName: "",
      boxshopPurchaseEmailSubject: "",
      boxshopTermsConditions: "",
      ccSiteEmailInSaveQuote: false,
      checkForExistingTenant: false,
      creditCardForAutobill: {
        enabled: true,
      },
      completeMoveinUrl: "",
      country: "AU",
      currency: "AUD",
      currencySymbol: "$",
      dateFormat: "yyyy-MM-dd",
      datesClosed: "",
      delayedInsurance: {
        enabled: false,
        timings: {
          days: null,
          hours: null,
          minutes: null,
        },
      },
      directDebit: {
        enabled: false,
        creditAmount: 0,
      },
      documentVerification: {
        enabled: false,
        providerToUse: null,
        providers: {
          rapidId: {
            label: "RapidID",
            token: null,
          },
        },
      },
      doNotSendInvoiceSiteLinkWhenAutoBill: false,
      emailSchedules: {
        quoteEmail: {
          1: {
            subject: "Your Storage Quote",
          },
          2: {
            subject: "Did you forget something?",
            days: 5,
            hours: 0,
            minutes: 1,
          },
          3: {
            subject: "Don't miss out!",
            days: 2,
            hours: 0,
            minutes: 1,
          },
        },
        quoteUnlockFirstReminder: {
          days: null,
          hours: null,
          minutes: null,
        },
        quoteUnlockSecondReminder: {
          days: null,
          hours: null,
          minutes: null,
        },
        reservationNotMovedIn: {
          days: 0,
          hours: 0,
          mintues: null,
          minutes: 20,
        },
      },
      enquiryAPI: {
        numOptions: 3,
      },
      eSignInsuranceForm: {
        sFormName: null,
      },
      eSignInsuranceFormName: "",
      eSignMoveInDocumentNames: [],
      eSignMoveInDocuments: [],
      eSignReturnUrl: "",
      facilitySelfService: {
        boxshop: {
          background:
            "https://ik.imagekit.io/bytcx9plm/facility-self-service-default-boxshop.png",
        },
        enquiries: {
          background:
            "https://ik.imagekit.io/bytcx9plm/facility-self-service-default-enquiries.png",
        },
        moveOut: {
          background:
            "https://ik.imagekit.io/bytcx9plm/facility-self-service-default-moveout.png",
        },
        takePayment: {
          background:
            "https://ik.imagekit.io/bytcx9plm/facility-self-service-default-take-payment.png",
        },
      },
      features: {
        boxshop: "standard",
        "carousel-unit-listing": "standard",
        "facility-self-service": "standard",
        "facility-staff-self-service": "standard",
        "movein-wizard": "single-page",
        "reservation-with-fee-wizard": "standard",
        "tenant-accounts": "standard",
        "tiered-unit-listing": "standard",
        "unit-listing": "modern",
      },
      forceTaxInclusive: false,
      freeShippingDealAmount: 150,
      freeShippingDealEnabled: false,
      groundFloor: "1",
      hideBoxshop: false,
      hideDateOfBirth: true,
      hideInsurance: false,
      hideLicense: false,
      hideLicenseState: true,
      hidePostalCode: false,
      hidePrices: false,
      hideQuickSearch: false,
      hideState: false,
      hideUnitsMinAvailable: false,
      includeFutureMoveOut: false,
      includeReservedUnitsInOccupied: true,
      insuranceCustomFormat: "",
      insuranceEsignReturnUrl: "",
      insurancePolicyNumberRange: {
        end: null,
        start: null,
      },
      insurancePolicyNumberRefreshNum: null,
      insuranceRequired: false,
      insuranceSmsFollowUpContent: "",
      kioskUnitListing: "standard",
      language: {
        selectionOption: "auto-detect",
      },
      legacyPickupLocations: null,
      legacyPickupLocationsEnabled: false,
      locationPageUrl: "",
      marketingSurvey: {
        questions: {
          customerType: {
            display: true,
            required: true,
          },
          distanceFromFacility: {
            display: true,
            required: true,
          },
          whatStoring: {
            display: true,
            required: true,
          },
          whereHearAboutUs: {
            display: true,
            required: true,
          },
          whyStoring: {
            display: true,
            required: true,
          },
          whyStoringWithUs: {
            display: true,
            required: true,
          },
        },
        use: true,
      },
      mediumLargeSize: 14,
      minAvailableUnits: 0,
      moveinEmailSubject: "",
      moveinHideACP: false,
      moveinNumberOfDaysInAdvanceLimit: 14,
      moveinRedirectUrl: "",
      noAvailableUnitsText: "Call for Availability",
      notificationsAdditionalBCCAddresses: [],
      notificationsAdditionalCCAddresses: [],
      notificationsFromAddress: "exmouth@keepsafestorage.com.au",
      notificationsFromName: "Keepsafe Storage",
      notificationsReplyAddress: "",
      payLaterButtonText: "Pay Later",
      paymentGateways: {
        bypassSitelinkProcessing: false,
        gatewayToUse: "",
        paygate: {
          countryCode: "",
          currency: "",
          encryptionKey: "",
          locale: "",
          paygateId: "",
          payMethod: "",
        },
        paynamics: {
          countryCode: "PH",
          currency: "",
          merchantId: "",
          merchantKey: "",
          merchantTermsUrl: "",
          paymentMethods: ["bn", "cc", "dp", "gc", "pp"],
          secure3d: "try3d",
        },
        paypal: {
          clientId: "",
          clientSecret: "",
          currency: "",
          force3dsCheck: false,
          useTestEnv: false,
        },
        paytabs: {
          countryCode: "",
          merchantEmail: "",
          merchantId: "",
          merchantSiteUrl: "",
          messageLanguage: "",
          secretKey: "",
        },
        r6Pay: {
          currency: "",
          useTestEnv: false,
          accessToken: "",
        },
        use: false,
      },
      payNowButtonText: "Pay Now",
      pickupEnabled: true,
      pushRate: true,
      quickReserveButtonText: "Quick Reserve",
      saveQuoteButtonText: "Save My Quote",
      recaptcha: {
        enabled: true,
        secretKey: "6Lf5GTwoAAAAACOg3xVeVHJlt9MiGuzR7MI48VgM",
        siteKey: "6Lf5GTwoAAAAACOg3xVeVHJlt9MiGuzR7MI48VgM",
        tolerance: 0.5,
      },
      requireAutobill: false,
      reservationEmailSubject: "",
      reservationExpireOccupancyValues: {
        bands: [
          {
            days: 30,
            from: 0,
            to: 100,
          },
        ],
        enabled: false,
      },
      reservationExpireReservationDays: "7",
      reservationNumberOfDaysInAdvanceChargeFee: 0,
      reservationNumberOfDaysInAdvanceLimit: 7,
      reservationPopupText: "",
      saveQuotePopupText: "",
      resetPasswordUrl: "",
      scheduleFollowUpEmails: true,
      sendReservationEmailOnFeeFailure: false,
      shippingEnabled: false,
      shippingInventoryItem: null,
      showAreaInsteadOfDimensions: false,
      showAutobillTerms: false,
      showMoveInDateLimitMessage: false,
      showPricesButtonText: "Show Prices",
      showPricesCreatesLead: false,
      showPricesShowNeeded: true,
      showVehicleQuickSearch: false,
      showWeeklyRates: false,
      sitelinkCostRetrieveChargeNameSubstiutions: [],
      siteLinkLeaseFields: [],
      siteLogo: "https://ik.imagekit.io/bytcx9plm/sitelogo.png",
      siteOpeningDate: null,
      sizeSymbol: "m",
      smallMediumSize: 8,
      spaceCalculatorValues: {
        bedroom: 4,
        box: 0.05,
        garage: 7,
        highestValue: {
          area: 20,
          high: 30,
          low: 18,
        },
        largeItem: 1.5,
        largeRoom: 5,
        lowestValue: {
          area: 3,
          high: 5,
          low: 1,
        },
        room: 4,
        smallItem: 0.5,
        smallRoom: 3,
      },
      tenantAccounts: {
        autoPayment: {
          enabled: true,
        },
        enableMultiSiteLogin: {
          enabled: false,
        },
        invoiceHistory: {
          enabled: true,
        },
        notification: {
          enabled: false,
          content: null,
          ctaButton: {
            text: null,
          },
        },
        makePayment: {
          enabled: true,
        },
        paymentHistory: {
          enabled: true,
        },
        tenantInfo: {
          enabled: true,
        },
        uploadDocuments: {
          enabled: true,
          generalContent:
            "Please select & upload the following documents as a pdf or image.",
          proofOfAddress: {
            content:
              "Please upload a photo which has proof of your current address. Examples are bank statement, credit card statement or utility bill.",
            enabled: true,
            label: "Proof of Address",
          },
          proofOfId: {
            content:
              "Please upload a photo of one of your identity documents such as your Driver's Licence or National Identity Card in JPG format.",
            enabled: true,
            label: "Proof of Identification",
          },
          proofOfInsurance: {
            content:
              "Please upload a document which has proof of you being insured for your declared amount.",
            enabled: true,
            label: "Proof of Insurance",
          },
        },
      },
      tieredPricing: {
        cherryPickBasis: "lowestRate",
        hidePrices: false,
        hideQuickSearch: false,
        noAvailableUnitsText: "Call for Availability",
        showAvailableUnitsCount: false,
        showPricesShowNeeded: true,
        showTiersWithNoAvailableUnits: true,
        showVehicleQuickSearch: false,
      },
      twilio: {
        accountSid: "",
        authToken: "",
        enabled: false,
        senderId: "",
      },
      unitListing: {
        sortOrder: {
          primary: "size",
          secondary: "price",
          tertiary: "availability",
        },
        useMultilevel: true,
      },
      useAutoBilling: true,
      useBoxShopCoupons: false,
      useDealCoupons: false,
      useDescriptorTitle: false,
      useESign: true,
      useESignForInsuranceDocs: false,
      useWebRates: false,
      webhooks: {
        docUpload: {
          enabled: false,
          template: "",
          url: "",
        },
        enquiry: {
          enabled: false,
          template: "",
          url: "",
        },
        leadFollowUp: {
          enabled: false,
          template: "",
          url: "",
        },
        moveIn: {
          enabled: false,
          template: "",
          url: "",
        },
        pageLoad: {
          enabled: false,
          template: "",
          url: "",
        },
        reservation: {
          enabled: false,
          template: "",
          url: "",
        },
        reservationWithFee: {
          enabled: false,
          template: "",
          url: "",
        },
      },
      wizards: {
        moveinSingle: {
          allowIdUpload: true,
          allowProofOfAddressUpload: false,
          allowProofOfInsuranceUpload: false,
          hideAlternativeContact: false,
          hideBoxshop: true,
          hideDateOfBirth: false,
          hideDriversLicence: false,
          hideDriversLicenceState: true,
          hideInsurance: false,
          hideInsurancePicker: false,
          hidePostalCode: false,
          hideState: false,
          insuranceAcceptancePopoverText: "",
          insuranceAcceptanceText:
            "By ticking this box you accept and agree; that the insurance coverage option selected will cover the true replacement value of your goods declared, agree to the T&C’s below and understand the inclusions/exclusions of the policy.",
          insuranceContent: "",
          insuranceContentPopoverText: "",
          insuranceManualEntry: false,
          insuranceManualEntryRequired: false,
          insuranceRefusedPopoverText: "",
          insuranceRefusedText:
            "By ticking this box, you are choosing not to be covered by insurance and acknowledge that we will not be held responsible for any damaged or lost goods during your rental period.",
          insuranceRequired: false,
          requireAlternativeContactPhoneNumberField: true,
        },
        moveinStandard: {
          requireAlternativeContactPhoneNumberField: true,
        },
        reservationWithFeeStandard: {},
      },
    },
    skin: {
      accentColours: {
        primary: "#701605",
      },
      defaultUnitPicture: "https://ik.imagekit.io/bytcx9plm/3x3_f.png",
      highlightColour: "#dddddd",
      mainColour: "#e02b0a",
      moveinTimeRemaining: false,
    },
    token:
      "417a59f5c85b8cbe249297eba961ed97260b66e5feeaad512e071844cf058e5f51e4e47e1deb2c0876a7bbff964b1dbf",
    collections: {
      marketingSource: {
        name: "marketingSource",
        job: "CDQS/L009/marketingSource",
        status: "finished",
        timestamp: 1715992228927,
      },
      form: {
        name: "form",
        job: "CDQS/L009/form",
        status: "finished",
        timestamp: 1715992228928,
      },
      unitTypeGroup: {
        name: "unitTypeGroup",
        job: "CDQS/L009/unitTypeGroup",
        status: "finished",
        timestamp: 1715992228926,
      },
      paymentSettings: {
        name: "paymentSettings",
        job: "CDQS/L009/paymentSettings",
        status: "finished",
        timestamp: 1716077494262,
      },
      insuranceCoverage: {
        name: "insuranceCoverage",
        job: "CDQS/L009/insuranceCoverage",
        status: "finished",
        timestamp: 1715992228927,
      },
      unitsFull: {
        name: "unitsFull",
        job: "CDQS/L009/unitsFull",
        status: "finished",
        timestamp: 1715992228926,
      },
      chargeDescription: {
        name: "chargeDescription",
        job: "CDQS/L009/chargeDescription",
        status: "finished",
        timestamp: 1715992228926,
      },
      paymentTypes: {
        name: "paymentTypes",
        job: "CDQS/L009/paymentTypes",
        status: "finished",
        timestamp: 1715992228928,
      },
      site: {
        name: "site",
        job: "CDQS/L009/site",
        status: "finished",
        timestamp: 1715992228926,
      },
      discountPlan: {
        name: "discountPlan",
        job: "CDQS/L009/discountPlan",
        status: "finished",
        timestamp: 1715992228927,
      },
      inventory: {
        name: "inventory",
        job: "CDQS/L009/inventory",
        status: "finished",
        timestamp: 1715992228927,
      },
    },
    changeToken:
      "77f35f4af6416de8c989a38248abd8deee73bdfffafd5b2950549c0d79d6b2fb8d474144646b2e8a96569aea9129df53",
    changedAt: "2024-05-19T15:51:38.692Z",
    deleted: false,
    originalName: "KeepSafe Exmouth",
    scaConfiguration: {},
    personas: [],
    sCorpCode: "CDQS",
  },
  {
    SiteID: 31256,
    sLocationCode: "LSETUP",
    __v: 0,
    sGlobalSiteNum: "31256",
    iRegionalOptions: 1,
    iGMTTimeOffset: 10,
    sContactName: null,
    sEmailAddress: "ben@r6digital.com.au",
    sSiteName: "KBH Group of Companies",
    sSiteAddr1: "P.O. Box 156",
    sSiteCity: "North Freemantle",
    sSiteRegion: "WA",
    sSitePostalCode: "6159",
    sSiteCountry: "Australia",
    sSitePhone: "08 9200 2251",
    bUseInclusiveTaxation: true,
    dUpdated: "2024-05-18T14:05:22.510Z",
    uTS: "AAAAABA4lDY=",
    rapidstorEnabled: true,
    iMobileType: "0",
    iOnLineChargeType: "0",
    iFeatMaxUnits: "250",
    bFeatGate: "true",
    bFeatKiosk: "true",
    bFeatRevMgmt: "true",
    bFeatCreditCards: "false",
    bFeatCorpOffice: "true",
    bFeatAccounting: "true",
    bFeatRecordStorage: "false",
    bFeatACH: "true",
    bFeatMobileStorage: "false",
    bFeatPromoAdvanced: "false",
    bLiteVersion: "false",
    bTrial: "false",
    bSubscription: "false",
    bSiteDisabled: "false",
    dOvernightProcess: "2024-05-18T10:05:22.51-04:00",
    bZipCodeData_Use: "false",
    bClosedWeekdays: "false",
    bClosedSaturday: "false",
    bClosedSunday: "false",
    iIdentifier: "0",
    iBusinessType: "0",
    iSiteDataType: "1",
    iFacilityUsage: "0",
    iFacilityOwnership: "0",
    iFacilityMgmt: "0",
    iFacilityLocType: "0",
    iMobileBungoRules: "0",
    iOnLinePmtsAllowed: "0",
    iEdition: "1",
    iTerminalServices: "0",
    iDST: "0",
    dCreated: "2017-05-31T08:06:03.793-04:00",
    bPermanent: "false",
    bArchived: "false",
    iVerboseLogging: "0",
    iSiteLinkStoreTier: "1",
    iSubscriptionType: "0",
    tWeekdayStrt: "00:01:00",
    tWeekdayEnd: "23:58:00",
    tSaturdayStrt: "00:01:00",
    tSaturdayEnd: "23:58:00",
    tSundayStrt: "00:01:00",
    tSundayEnd: "23:58:00",
    sSiteIDCode: null,
    sSiteRegionCode: null,
    sSiteAddr2: null,
    sSiteFAX: ".",
    sSLBillingRef: null,
    bForcePushRates: "0",
    iWebRatesType: "0",
    token:
      "5082569e0de255b0c14d10eee40ce7df86ef0578ed215e1afc9d23fa02f265202e531d18657e4c0a445f6cba04584962",
    changedAt: "2024-05-19T05:16:58.494Z",
    changeToken:
      "f5aba6402c129f639a285d66f889dc9e2903a51952878f66316f0deb192179d4e6eb308cfea1db8978802277a9465a96",
    deleted: false,
    administrative: {
      boxshopEnabled: true,
      availableForUse: false,
      insuranceEnabled: false,
      merchEnabled: false,
      refreshEnabled: false,
      rslite: false,
      rsliteKey: "N/A",
      testMode: false,
      carouselListing: false,
      useMtasForAuth: false,
    },
    rapidstor: {
      siteLogo:
        "https://ik.imagekit.io/bytcx9plm/CDQS-LSETUP-logo-cjilmqd4m01exhfd6mo4byijd.png",
      billingDefault: "MonthlyAnniversary",
      sizeSymbol: "m",
      areaSizeSymbol: "m²",
      allowMoveIn: true,
      allowOriginUrl: [],
      allowReservation: false,
      allowedCreditCardTypes: {
        amex: true,
        mastercard: true,
        visa: true,
      },
      assistanceMoving: false,
      assistanceMovingEmailAddress: "",
      attachLeaseToMoveInConfirmationEmail: true,
      attachReceiptToMoveInConfirmationEmail: true,
      autoBillCheckedByDefault: false,
      autoESignRedirect: true,
      autoOptInSMS: false,
      bookOnlineDiscount: 0,
      boxshopPurchaseAttachmentName: "",
      boxshopPurchaseEmailSubject: "",
      checkForExistingTenant: false,
      completeMoveinURL: "",
      country: "AU",
      currency: "AUD",
      currencySymbol: "$",
      dateFormat: "yyyy-MM-dd",
      doNotSendInvoiceSiteLinkWhenAutoBill: false,
      eSignReturnUrl: "http://localhost:5173/locations/kbh-group-of-companies/units",
      enquiryAPI: {
        numOptions: 3,
      },
      facilitySelfService: {
        boxshop: {
          background:
            "https://ik.imagekit.io/bytcx9plm/facility-self-service-default-boxshop.png",
        },
        enquiries: {
          background:
            "https://ik.imagekit.io/bytcx9plm/facility-self-service-default-enquiries.png",
        },
        moveOut: {
          background:
            "https://ik.imagekit.io/bytcx9plm/facility-self-service-default-moveout.png",
        },
        takePayment: {
          background:
            "https://ik.imagekit.io/bytcx9plm/facility-self-service-default-take-payment.png",
        },
      },
      features: {
        boxshop: "standard",
        "facility-self-service": "standard",
        "facility-staff-self-service": "standard",
        "movein-wizard": "single-page",
        "reservation-with-fee-wizard": "standard",
        "tenant-accounts": "standard",
        "tiered-unit-listing": "standard",
        "unit-listing": "standard",
        "carousel-unit-listing": "standard",
      },
      forceTaxInclusive: false,
      freeShippingDealAmount: 150,
      freeShippingDealEnabled: false,
      groundFloor: 0,
      hideBoxshop: false,
      hideDateOfBirth: true,
      hideInsurance: false,
      hideLicense: false,
      hideLicenseState: true,
      hidePostalCode: false,
      hidePrices: false,
      hideQuickSearch: false,
      hideState: false,
      hideUnitsMinAvailable: false,
      insuranceCustomFormat: "",
      insuranceRequired: false,
      language: {
        selectionOption: "auto-detect",
      },
      legacyPickupLocationsEnabled: false,
      locationPageUrl: "",
      marketingSurvey: {
        questions: {
          customerType: {
            display: true,
            required: true,
          },
          distanceFromFacility: {
            display: true,
            required: true,
          },
          whatStoring: {
            display: true,
            required: true,
          },
          whereHearAboutUs: {
            display: true,
            required: true,
          },
          whyStoring: {
            display: true,
            required: true,
          },
          whyStoringWithUs: {
            display: true,
            required: true,
          },
        },
        use: true,
      },
      mediumLargeSize: 9,
      minAvailableUnits: 0,
      moveinEmailSubject: "",
      moveinHideACP: false,
      moveinNumberOfDaysInAdvanceLimit: 7,
      moveinRedirectUrl: "",
      noAvailableUnitsText: "Call for Availability",
      notificationsAdditionalBCCAddresses: [],
      notificationsAdditionalCCAddresses: [],
      notificationsFromAddress: "storage@keepsafestorage.com.au",
      notificationsReplyAddress: "storage@keepsafestorage.com.au",
      payLaterButtonText: "Pay Later",
      payNowButtonText: "Pay Now",
      paymentGateways: {
        bypassSitelinkProcessing: false,
        gatewayToUse: "",
        paygate: {
          countryCode: "",
          currency: "",
          encryptionKey: "",
          locale: "",
          payMethod: "",
          paygateId: "",
        },
        paynamics: {
          countryCode: "PH",
          currency: "",
          merchantId: "",
          merchantKey: "",
          merchantTermsUrl: "",
          paymentMethods: ["cc", "bn", "gc", "pp", "dp"],
          secure3d: "try3d",
        },
        paypal: {
          clientId: "",
          clientSecret: "",
          currency: "",
          useTestEnv: false,
          force3dsCheck: false,
        },
        paytabs: {
          countryCode: "",
          merchantEmail: "",
          merchantSiteUrl: "",
          messageLanguage: "",
          secretKey: "",
          merchantId: "",
        },
        use: false,
        r6Pay: {
          currency: "",
          useTestEnv: false,
          accessToken: "",
        },
      },
      pushRate: false,
      quickReserveButtonText: "Quick Reserve",
      recaptcha: {
        enabled: true,
        secretKey: "6LeKlOYnAAAAAA2S2-5gNwORUeu3RRY-abortC9c",
        siteKey: "6LeKlOYnAAAAAPCO99RSnuiHr5fQoEar2Yhu2SUB",
        tolerance: "0.4",
      },
      reservationEmailSubject: "",
      reservationExpireOccupancyValues: {
        bands: [
          {
            from: 0,
            to: 100,
            days: 30,
          },
        ],
        enabled: false,
      },
      reservationExpireReservationDays: 30,
      reservationNumberOfDaysInAdvanceChargeFee: 365,
      reservationNumberOfDaysInAdvanceLimit: 30,
      reservationPopupText: "",
      scheduleFollowUpEmails: true,
      shippingEnabled: false,
      showAreaInsteadOfDimensions: false,
      showAutobillTerms: false,
      showPricesButtonText: "Show Prices",
      showPricesShowNeeded: true,
      showVehicleQuickSearch: false,
      showWeeklyRates: false,
      siteLinkLeaseFields: [],
      sitelinkCostRetrieveChargeNameSubstiutions: [],
      smallMediumSize: 3,
      spaceCalculatorValues: {
        bedroom: 4,
        box: 0.05,
        garage: 7,
        highestValue: {
          area: 20,
          high: 30,
          low: 18,
        },
        largeItem: 1.5,
        largeRoom: 5,
        lowestValue: {
          area: 3,
          high: 5,
          low: 1,
        },
        room: 4,
        smallItem: 0.5,
        smallRoom: 3,
      },
      tenantAccounts: {
        autoPayment: {
          enabled: true,
        },
        invoiceHistory: {
          enabled: true,
        },
        makePayment: {
          enabled: true,
        },
        paymentHistory: {
          enabled: true,
        },
        tenantInfo: {
          enabled: true,
        },
        uploadIdentification: {
          enabled: true,
        },
        uploadDocuments: {
          enabled: true,
          generalContent:
            "Please select & upload the following documents as a pdf or image.",
          proofOfAddress: {
            content:
              "Please upload a photo which has proof of your current address. Examples are bank statement, credit card statement or utility bill.",
            enabled: true,
            label: "Proof of Address",
          },
          proofOfId: {
            content:
              "Please upload a photo of one of your identity documents such as your Driver's Licence or National Identity Card in JPG format.",
            enabled: true,
            label: "Proof of Identification",
          },
          proofOfInsurance: {
            content:
              "Please upload a document which has proof of you being insured for your declared amount.",
            enabled: true,
            label: "Proof of Insurance",
          },
        },
        notification: {
          content: null,
          ctaButton: {
            text: null,
          },
          enabled: false,
        },
        enableMultiSiteLogin: {
          enabled: false,
        },
      },
      tieredPricing: {
        cherryPickBasis: "lowestRate",
        hidePrices: false,
        hideQuickSearch: false,
        noAvailableUnitsText: "Call for Availability",
        showAvailableUnitsCount: false,
        showPricesShowNeeded: true,
        showTiersWithNoAvailableUnits: true,
        showVehicleQuickSearch: false,
      },
      unitListing: {
        sortOrder: {
          primary: "size",
          secondary: "price",
          tertiary: "availability",
        },
        useMultilevel: false,
      },
      useAutoBilling: true,
      useBoxShopCoupons: false,
      useDealCoupons: false,
      useDescriptorTitle: false,
      useESign: false,
      useWebRates: false,
      webhooks: {
        moveIn: {
          enabled: false,
          template: "",
          url: "",
        },
        pageLoad: {
          enabled: false,
          template: "",
          url: "",
        },
        reservation: {
          enabled: false,
          template: "",
          url: "",
        },
        reservationWithFee: {
          enabled: false,
          template: "",
          url: "",
        },
        docUpload: {
          enabled: false,
          template: "",
          url: "",
        },
        leadFollowUp: {
          enabled: false,
          template: "",
          url: "",
        },
        enquiry: {
          enabled: false,
          template: "",
          url: "",
        },
      },
      wizards: {
        moveinSingle: {
          allowSelfInsurance: false,
          hideAlternativeContact: true,
          hideBoxshop: false,
          hideDateOfBirth: true,
          hideDriversLicence: false,
          hideDriversLicenceState: true,
          hideInsurance: false,
          hidePostalCode: false,
          hideState: false,
          insuranceManualEntry: false,
          insuranceRequired: false,
          requireAlternativeContactPhoneNumberField: true,
          allowIdUpload: false,
          allowProofOfAddressUpload: false,
          allowProofOfInsuranceUpload: false,
          hideInsurancePicker: false,
          insuranceAcceptancePopoverText: "",
          insuranceAcceptanceText:
            "By ticking this box you accept and agree; that the insurance coverage option selected will cover the true replacement value of your goods declared, agree to the T&C’s below and understand the inclusions/exclusions of the policy.",
          insuranceContent: "",
          insuranceContentPopoverText: "",
          insuranceManualEntryRequired: false,
          insuranceRefusedPopoverText: "",
          insuranceRefusedText:
            "By ticking this box, you are choosing not to be covered by insurance and acknowledge that we will not be held responsible for any damaged or lost goods during your rental period.",
        },
        moveinStandard: {
          requireAlternativeContactPhoneNumberField: true,
        },
        reservationWithFeeStandard: {},
      },
      allowReservationsWhenNoAvailability: false,
      boxshopCategoryAlphaOrder: false,
      boxshopTermsConditions: "",
      datesClosed: "",
      eSignInsuranceFormName: "",
      eSignMoveInDocumentNames: [],
      eSignMoveInDocuments: [],
      includeFutureMoveOut: false,
      includeReservedUnitsInOccupied: false,
      insuranceEsignReturnUrl: "",
      pickupEnabled: true,
      resetPasswordUrl: "",
      showMoveInDateLimitMessage: false,
      useESignForInsuranceDocs: false,
      attachInsuranceDocsToMoveInConfirmationEmail: false,
      delayedInsurance: {
        enabled: false,
        timings: {
          days: null,
          hours: null,
          minutes: null,
        },
      },
      documentVerification: {
        enabled: false,
        providerToUse: null,
        providers: {
          rapidId: {
            label: "RapidID",
            token: null,
          },
        },
      },
      eSignInsuranceForm: {
        sFormName: null,
      },
      emailSchedules: {
        quoteUnlockFirstReminder: {
          days: null,
          hours: null,
          minutes: null,
        },
        quoteUnlockSecondReminder: {
          days: null,
          hours: null,
          minutes: null,
        },
        reservationNotMovedIn: {
          days: 0,
          hours: 0,
          mintues: null,
          minutes: 1,
          subject: "Test Abandonment",
        },
        quoteEmail: {
          1: {
            subject: "Quote Saved",
          },
          2: {
            days: 0,
            hours: 0,
            minutes: 1,
            subject: "Quote Saved 2",
          },
          3: {
            days: 0,
            hours: 0,
            minutes: 2,
            subject: "Quote Saved 3",
          },
        },
      },
      insurancePolicyNumberRange: {
        end: null,
        start: null,
      },
      insurancePolicyNumberRefreshNum: null,
      insuranceSmsFollowUpContent: "",
      kioskUnitListing: "standard",
      legacyPickupLocations: null,
      notificationsFromName: "",
      shippingInventoryItem: null,
      siteOpeningDate: null,
      twilio: {
        accountSid: "",
        authToken: "",
        enabled: false,
        senderId: "",
      },
      directDebit: {
        creditAmount: 0,
        enabled: false,
      },
      requireAutobill: false,
      sendReservationEmailOnFeeFailure: false,
      allowSaveQuote: true,
      completeMoveinUrl: "",
      saveQuoteButtonText: "Save My Quote",
      saveQuotePopupText: "",
      ccSiteEmailInSaveQuote: true,
      creditCardForAutobill: {
        enabled: true,
      },
      showPricesCreatesLead: false,
    },
    ownerId: "11",
    languageId: "1",
    divisionId: "11",
    DivisionID: "-999",
    LanguageID: "1",
    OwnerID: "11",
    fees: {
      adminFee: 20,
      cleaningFee: 50,
      lateDays: 3,
      lateFee: 20,
      moveOutNotice: 2,
      nsfFee: 20,
      securityDeposit: 100,
    },
    hours: {
      gateClose: "5:00pm",
      gateCloseSaturday: "5:00pm",
      gateCloseSunday: "5:00pm",
      gateOpen: "9:00am",
      gateOpenSaturday: "9:00am",
      gateOpenSunday: "9:00am",
      officeFridayClose: "5:00pm",
      officeFridayOpen: "9:00am",
      officeMondayClose: "5:00pm",
      officeMondayOpen: "9:00am",
      officeSaturdayClose: "2:00pm",
      officeSaturdayOpen: "9:00am",
      officeSundayClose: "",
      officeSundayOpen: "CLOSED",
      officeThursdayClose: "5:00pm",
      officeThursdayOpen: "9:00am",
      officeTuesdayClose: "5:00pm",
      officeTuesdayOpen: "9:00am",
      officeWednesdayClose: "5:00pm",
      officeWednesdayOpen: "9:00am",
    },
    skin: {
      defaultUnitPicture: "https://ik.imagekit.io/bytcx9plm/3x3_f.png",
      highlightColour: "#ffffff",
      mainColour: "#f09a05",
      moveinTimeRemaining: false,
      accentColours: {},
    },
    pdfFonts: {
      lease: "Arial",
      receipt: "Arial",
      insuranceDocs: "Arial",
    },
    scaConfiguration: {},
    collections: {
      inventory: {
        name: "inventory",
        job: "CDQS/LSETUP/inventory",
        status: "finished",
        timestamp: 1715992228928,
      },
      unitsFull: {
        name: "unitsFull",
        job: "CDQS/LSETUP/unitsFull",
        status: "finished",
        timestamp: 1715992228928,
      },
      site: {
        name: "site",
        job: "CDQS/LSETUP/site",
        status: "finished",
        timestamp: 1715992228928,
      },
      form: {
        name: "form",
        job: "CDQS/LSETUP/form",
        status: "finished",
        timestamp: 1715992228929,
      },
      marketingSource: {
        name: "marketingSource",
        job: "CDQS/LSETUP/marketingSource",
        status: "finished",
        timestamp: 1715992228929,
      },
      paymentTypes: {
        name: "paymentTypes",
        job: "CDQS/LSETUP/paymentTypes",
        status: "finished",
        timestamp: 1715992228929,
      },
      unitTypeGroup: {
        name: "unitTypeGroup",
        job: "CDQS/LSETUP/unitTypeGroup",
        status: "finished",
        timestamp: 1715992228928,
      },
      insuranceCoverage: {
        name: "insuranceCoverage",
        job: "CDQS/LSETUP/insuranceCoverage",
        status: "finished",
        timestamp: 1715992228929,
      },
      paymentSettings: {
        name: "paymentSettings",
        job: "CDQS/LSETUP/paymentSettings",
        status: "finished",
        timestamp: 1715992228929,
      },
      chargeDescription: {
        name: "chargeDescription",
        job: "CDQS/LSETUP/chargeDescription",
        status: "finished",
        timestamp: 1715992228928,
      },
      discountPlan: {
        name: "discountPlan",
        job: "CDQS/LSETUP/discountPlan",
        status: "finished",
        timestamp: 1715992228929,
      },
    },
    friendlyName: null,
    originalName: "KBH Group of Companies",
    Ret_Code: "-99",
    Ret_Msg: "General Exception from LogOn",
    personas: [],
    sCorpCode: "CDQS",
    dSaturdayEnd: "2008-07-02T23:58:00-04:00",
    dSaturdayStrt: "2008-07-02T00:01:00-04:00",
    dSundayEnd: "2008-07-02T23:58:00-04:00",
    dSundayStrt: "2008-07-02T00:01:00-04:00",
    dWeekdayEnd: "2008-07-02T23:58:00-04:00",
    dWeekdayStrt: "2008-07-02T00:01:00-04:00",
    dcLatitude: "0.0000000000",
    dcLongitude: "0.0000000000",
    sLegalName: null,
    sLocationDesc: null,
    sTaxNumber: null,
    sWebSiteURL: null,
  },
];
export default defaultLocations;
